import * as angular from 'angular';
import * as moment from 'moment'
import * as _ from 'underscore'
import swal from 'sweetalert2'
import ngCookies from 'angular-cookies'

export const app = angular.module('wpMarketplace', [require('angular-ui-bootstrap'), 'ui.router.upgrade', require('angular-sanitize'), 'ngCookies']);

angular.module('wpMarketplace').controller("wpMarketplaceController", ['$scope', '$http', '$rootScope', '$location', '$state', '$window',
    '$timeout', '$filter', '$sce', 'profileService', 'apiService', 'clientConfigService', '$cookies',
    function($scope, $http, $rootScope,
        $location, $state, $window, $timeout, $filter, $sce, profileService, apiService, clientConfigService, $cookies) {


        /*
            //check if we are in a dev environment - if we are, use the api url
            if( $location.port() === 8888 ){
                $rootScope.api = 'http://api.worryandpeace:8888';
            } else if ( $location.host() === 'marketplace-dev.worryandpeace.com' ) {
                $rootScope.api = 'https://houston.cycler.co.uk';
            } else {
                $rootScope.api = 'https://houston.cycler.co.uk';
                //$rootScope.api = 'https://houston.cycler.co.uk';
            }
        */
        $rootScope.apiEndpoint = apiService.apiEndpoint;

        //set up objects for editing elements of the staff profile
        $scope.editMobileValue = {};
        $scope.editEmailValue = {};
        $scope.editBioValue = {};
        //get the web token from localstorage

        $rootScope.token = $cookies.get('membrs');



        //decode the token taken from localstorage

        //var tokenPayload = jwtHelper.decodeToken($scope.token);
        //$scope.adminId = tokenPayload.adminId;



        // clientConfigService.retrieveClientConfig()

        //     clientConfigService.clientConfig.subscribe((x)=>{

        //     $scope.clientConfig = x;
        //     $rootScope.clientConfig = x;
        //     $rootScope.marketplaceProfile = x;

        //  })


        $scope.staffProfile = {};
        profileService.profile.subscribe(function(value) {
            angular.copy(value, $scope.staffProfile);



            $scope.adminId = $scope.staffProfile.id



        });

        //initial search filter value
        $scope.search = {};
        $scope.search.filter = 'customers';

        //switch for mobile view
        if ($window.innerWidth < 768) {
            $rootScope.mobileView = true;
        } else {
            $rootScope.mobileView = false;
        }

        $rootScope.editProduct = false;
        $rootScope.editProductInfo = function() {
            if ($rootScope.editProduct == false) {
                $rootScope.editProduct = true;
            } else {
                $rootScope.editProduct = false;
            }
        }

        var docFilepickerOptions = {
            mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
            folders: true,
            //container: 'window',
            services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE'],
            multiple: false
        }

        // ============================================================================================================= //
        // FILEPICKER KEY - WEB SERVICES ONE =========================================================================== //
        filepicker.setKey("ADFgKR8OMTVur7o7iAIbrz");
        // ============================================================================================================= //
        // GET STAFF MEMBER PROFILE ==================================================================================== //
        apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
            $rootScope.staffProfile = response;
        });

        $rootScope.insurances = [{}]; //list of the whole insurance product objects, names, id, icon, etc
        $rootScope.insurancesNames = new Array; //list used to populate the dropdown/search
        apiService.request('GET', '/products', { cache: true }).then(function(response) {
            $rootScope.insurances = response;
            if ($rootScope.insurances != undefined) {
                var i;
                for (i = 0; i < $rootScope.insurances.length; i++) {
                    $rootScope.insurancesNames.push($scope.insurances[i].name);
                }
            }
        });

        //ALL INSURANCES - THIS IS ONLY NEEDED FOR POPULATING THE PRODUCT LIST ON THE REPORT DROPDOWN
        // $rootScope.insurancesAll = [{}]; //list of the whole insurance product objects, names, id, icon, etc
        // $rootScope.insurancesNamesAll = new Array; //list used to populate the dropdown/search
        // $http.get($scope.api+'/products?group=all', {cache: true}).then(function(response){
        //     $rootScope.insurancesAll = response.data.data;
        //     if($rootScope.insurancesAll != undefined){
        //         for(i = 0; i < $rootScope.insurancesAll.length; i++){
        //             $rootScope.insurancesNamesAll.push($scope.insurancesAll[i].name);
        //         }
        //     }
        // });

        //ABOVE REMOVED AS NOW IN THE CONFIG
        //CLIENT CONFIG - THIS IS NEEDED TO SHOW/HIDE CONTENT BASED ON CLIENT CONFIG ACESS
        apiService.request('GET', '/provider').then(function(response) {
            $rootScope.clientConfig = response;
            var currentClient = {};
            currentClient.name = $rootScope.clientConfig.name;
            currentClient.id = $rootScope.clientConfig.id;
            currentClient.products = $rootScope.clientConfig.products;
            currentClient.insurers = $rootScope.clientConfig.insurers;
            currentClient.admins = $rootScope.clientConfig.admins;
            currentClient.shortcode = $rootScope.clientConfig.shortcode;
            currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
            currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
            currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
            currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
            currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
            currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
            currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;

            if ($rootScope.clientConfig.clients) {
                $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                $rootScope.clientsAll.unshift(currentClient);
            } else {
                $rootScope.clientsAll = [];
                $rootScope.clientsAll.push(currentClient);
            }
            //IF CAN VIEW CLIENTS DO THE BELOW
            if ($rootScope.clientConfig.view_all_providers) {
                //GET ALL INSURERS
                apiService.request('GET', '/insurers').then(function(response) {
                    $rootScope.insurersAll = response;
                });
                //GET ALL PRODUCTS
                apiService.request('GET', '/products').then(function(response) {
                    $rootScope.productsAll = response;
                });
            }
            //BUILD MARKETPLACE PROFILE
            $rootScope.marketplaceProfile = {};
            $rootScope.marketplaceProfile.id = $rootScope.clientConfig.id;
            $rootScope.marketplaceProfile.contact_email = $rootScope.clientConfig.contact_email;
            $rootScope.marketplaceProfile.status = $rootScope.clientConfig.status;
            $rootScope.marketplaceProfile.speciality = $rootScope.clientConfig.speciality;
            $rootScope.marketplaceProfile.founded = $rootScope.clientConfig.founded;
            $rootScope.marketplaceProfile.profile_url = $rootScope.clientConfig.profile_url;
            $rootScope.marketplaceProfile.profile_text = $rootScope.clientConfig.profile_text;
            $rootScope.marketplaceProfile.handle = $rootScope.clientConfig.handle;
            $rootScope.marketplaceProfile.function = $rootScope.clientConfig.function;
            $rootScope.marketplaceProfile.logo_black_background = $rootScope.clientConfig.logo_black_background;
            $rootScope.marketplaceProfile.logo_black_background_preview = $rootScope.clientConfig.logo_black_background;
            $rootScope.marketplaceProfile.logo_grey_background = $rootScope.clientConfig.logo_grey_background;
            $rootScope.marketplaceProfile.logo_grey_background_preview = $rootScope.clientConfig.logo_grey_background;
            $rootScope.marketplaceProfile.logo_avatar = $rootScope.clientConfig.logo_avatar;
            $rootScope.marketplaceProfile.logo_avatar_preview = $rootScope.clientConfig.logo_avatar;


        });






        // ============================================================================================================= //
        // ADDING A NEW PROFILE PICTURE TO A PROFILE =================================================================== //
        $scope.profilePicture = function(profile) {
                filepicker.pick({
                        mimetypes: ['image/jpeg', 'image/png'],
                        conversions: ['crop', 'rotate', 'filter'],
                        cropRatio: 1 / 1,
                        cropForce: true,
                        imageDim: [800, 800],
                        imageMax: [800, 800],
                        services: ['COMPUTER', 'DROPBOX', 'FACEBOOK', 'INSTAGRAM', 'TWITTER', 'CONVERT']
                    },
                    function(Blob) {
                        $scope.staffProfile.profile_image = Blob.key;
                        var data = {
                            id: profile.id,
                            data: profile
                        }
                        apiService.request('PUT', '/staff', {}, data).then(function(response) {
                            apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                                $scope.staffProfile = response;
                            });
                        });
                    },
                    function(FPError) {
                        //console.log('Error message', FPError.toString());
                    }
                );
            }
            // ============================================================================================================= //
            // ADDING A NEW MARKETPLACE LOGO BLACK TO A PROFILE =================================================================== //
        $rootScope.profileLogoBlack = function(profile) {
                filepicker.pick({
                        mimetypes: ['image/png', 'image/svg'],
                        conversions: ['crop', 'rotate', 'filter'],

                        imageDim: [null, 40],
                        imageMax: [420, 40],
                        services: ['COMPUTER', 'DROPBOX', 'TWITTER', 'CONVERT']
                    },
                    function(Blob) {
                        $rootScope.editMarketplaceProfile.logo_black_background_preview = Blob.url;
                        $rootScope.editMarketplaceProfile.logo_black_background = Blob.key;
                        //console.log($rootScope.editMarketplaceProfile.logo_black_background_preview);
                        $rootScope.$apply();
                    },
                    function(FPError) {
                        //console.log('Error message', FPError.toString());
                    }
                );
            }
            // ============================================================================================================= //
            // ADDING A NEW MARKETPLACE LOGO GREY TO A PROFILE =================================================================== //
        $rootScope.profileLogoGrey = function(profile) {
                filepicker.pick({
                        mimetypes: ['image/png', 'image/svg'],
                        conversions: ['crop', 'rotate', 'filter'],
                        imageDim: [null, 40],
                        imageMax: [420, 40],
                        services: ['COMPUTER', 'DROPBOX', 'TWITTER', 'CONVERT']
                    },
                    function(Blob) {
                        $rootScope.editMarketplaceProfile.logo_grey_background_preview = Blob.url;
                        $rootScope.editMarketplaceProfile.logo_grey_background = Blob.key;
                        //console.log($rootScope.editMarketplaceProfile.logo_grey_background_preview);
                        $rootScope.$apply();
                    },
                    function(FPError) {
                        //console.log('Error message', FPError.toString());
                    }
                );
            }
            // ============================================================================================================= //
            // ADDING A NEW MARKETPLACE LOGO GREY TO A PROFILE =================================================================== //
        $rootScope.profileLogoAvatar = function(profile) {
            filepicker.pick({
                    mimetypes: ['image/png', 'image/svg', 'image/jpeg', 'image/jpg', 'image/gif'],
                    conversions: ['crop', 'rotate', 'filter'],
                    cropRatio: 1 / 1,
                    cropForce: true,
                    imageDim: [800, 800],
                    imageMax: [800, 800],
                    services: ['COMPUTER', 'DROPBOX', 'TWITTER', 'CONVERT']
                },
                function(Blob) {
                    $rootScope.editMarketplaceProfile.logo_avatar_preview = Blob.url;
                    $rootScope.editMarketplaceProfile.logo_avatar = Blob.key;
                    //console.log($rootScope.editMarketplaceProfile.logo_grey_background_preview);
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }

        // ==================================================================================================================== //
        // MATCHING A QUOTE PRODUCT TO CLIENT CONFIG PRODUCTS ======================================================= //
        $rootScope.matchQuoteProduct = function(id) {
            var array = $rootScope.clientConfig.products;
            var match = _.findWhere(_.flatten(array), { id: parseInt(id) })
            return match
        }

        // ==================================================================================================================== //
        // ADDING A DOCUMENT TO A QUOTE RATHER THAN AN OPTION WITHIN IT ======================================================= //
        $rootScope.addDocumentOnQuote = function(quoteId) {

                filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                        $('.add-document-to-quote-btn').prop('disabled', true);
                        var dataToPush = {
                            filename: Blob[0].filename,
                            url: Blob[0].url,
                            mimetype: Blob[0].mimetype,
                            key: Blob[0].key
                        }
                        apiService.request('POST', '/quote/' + quoteId + '/document', {}, dataToPush).then(function(response) {
                            $timeout(function() { $('.add-document-to-quote-btn').prop('disabled', false); }, 2000);
                            if (response.status == 200) {
                                apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                    $rootScope.quotes = response;
                                    var i = 0;
                                    for (i = 0; i < $rootScope.quotes.length; i++) {
                                        if ($rootScope.quotes[i].status != null) {
                                            $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                        }
                                    }
                                });
                            }
                        });
                    },
                    function(FPError) {

                        $('.add-document-to-quote-btn').prop('disabled', false);
                    }
                );
            }
            // ==================================================================================================================== //
            // DELETING A DOCUMENT TO A QUOTE RATHER THAN AN OPTION WITHIN IT ===================================================== //
        $scope.deleteDocumentOnQuote = function(index, product) {
            swal({
                title: "Are you sure you want to delete this attachment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {

                apiService.request('DELETE', '/quote/' + product.id + '/document/' + product.documents[index].filename).then(function(response) {
                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                        $rootScope.quotes = response;
                        var i = 0;
                        for (i = 0; i < $rootScope.quotes.length; i++) {
                            if ($rootScope.quotes[i].status != null) {
                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                            }
                        }
                    });
                });
            }).catch(swal.noop);
        }

        // ============================================================================================================= //
        // EDIT BIO ON THE STAFF PROFILE =============================================================================== //
        $scope.editBioEdit = function() {
            $scope.editBioValue.newBio = $scope.staffProfile.profile;
            $scope.editBio = true;
        }
        $scope.editBioSave = function(profile, id) {
            var data = {
                id: id,
                data: profile
            }
            apiService.request('PUT', '/staff', {}, data).then(function(response) {
                apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                    $scope.staffProfile = response;
                });
                $scope.editBio = false;
            });
        }
        $scope.editBioCancel = function() {
                apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                    $scope.staffProfile = response;
                });
                $scope.editBio = false;
            }
            // ============================================================================================================= //
            // EDIT EMAIL ADDRESS ON THE STAFF PROFILE ===================================================================== //
        $scope.editEmailEdit = function() {
            $scope.editEmailValue.value = $scope.staffProfile.email;
            $scope.editEmail = true;
        }
        $scope.editEmailSave = function(profile, id) {
            var data = {
                id: id,
                data: profile
            }
            apiService.request('PUT', '/staff', {}, data).then(function(response) {
                apiService.request('GET', +'/staff/' + $scope.adminId).then(function(response) {
                    $rootScope.staffProfile = response;
                });
            });
            $scope.editEmail = false;
        }
        $scope.editEmailCancel = function() {
                apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                    $rootScope.staffProfile = response;
                });
                $scope.editEmail = false;
            }
            // ============================================================================================================= //
            // EDIT MOBILE NUMBER ON THE STAFF PROFILE ===================================================================== //
        $scope.editMobileEdit = function() {
            $scope.editMobileValue.newMobileNumber = $scope.staffProfile.phone;
            $scope.editMobile = true;
        }
        $scope.editMobileSave = function(profile, id) {
            var data = {
                id: id,
                data: profile
            }
            apiService.request('PUT', '/staff', {}, data).then(function(response) {
                apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                    $rootScope.staffProfile = response;
                });
            });
            $scope.editMobile = false;
        }
        $scope.editMobileCancel = function() {
            apiService.request('GET', '/staff/' + $scope.adminId).then(function(response) {
                $rootScope.staffProfile = response;
            });
            $scope.editMobile = false;
        }

        // ==================================================================================================================== //
        // OPENS EDIT MARKETPLACE MODAL =========================================================================== //
        $rootScope.editMarketplaceProfile = function(client) {

            if (!client) {
                $rootScope.editMarketplaceProfile = angular.copy($rootScope.marketplaceProfile);
            } else {

                // $rootScope.editMarketplaceProfile = angular.copy($rootScope.marketplaceProfile);
                // $rootScope.editMarketplaceProfile.logo_black_background_preview = angular.copy($rootScope.marketplaceProfile.logo_black_background);
                // $rootScope.editMarketplaceProfile.logo_grey_background_preview = angular.copy($rootScope.marketplaceProfile.logo_grey_background);
                // $rootScope.editMarketplaceProfile.logo_avatar_preview = angular.copy($rootScope.marketplaceProfile.logo_avatar);
                $rootScope.editMarketplaceProfile = client;
                $rootScope.editMarketplaceProfile.logo_black_background_preview = client.logo_black_background;
                $rootScope.editMarketplaceProfile.logo_grey_background_preview = client.logo_grey_background;
                $rootScope.editMarketplaceProfile.logo_avatar_preview = client.logo_avatar;



            }
            $rootScope.editMarketplaceProfileSuccess = null;
            $('#editMarketplaceProfileModal').modal('show');
        }

        // ==================================================================================================================== //
        // CLOSES EDIT MARKETPLACE MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeEditMarketplaceProfile = function() {
            $('#editMarketplaceProfileModal').modal('hide');
            $rootScope.editMarketplaceProfile = null;
            $rootScope.editMarketplaceProfileSuccess = null;
        }

        // ==================================================================================================================== //
        // OPENS ADD IMEI MODAL =========================================================================== //
        $rootScope.addNextGenImeiModal = function(policy) {

            $rootScope.addImei = {};
            $rootScope.addImei.policy_data = policy.policy_data;
            $rootScope.addImei.id = policy.id;
            $('#addNextGenImeiModal').modal('show');
        }

        // ==================================================================================================================== //
        // CLOSES ADD IMEI MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeNextGenImeiModal = function() {
            $('#addNextGenImeiModal').modal('hide');

        }

        // ==================================================================================================================== //
        // OPENS ADD IMEI MODAL =========================================================================== //
        $rootScope.submitNextGenImeiModal = function(imei) {

            imei.policy_data.payload.policy.devices[0].device.imei = imei.deviceImei;

            $rootScope.addingDeviceImei = true;
            var dataToSend = {
                'payload': imei.policy_data.payload
            }

            apiService.request('PUT', '/policy/' + imei.id + '/json', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $timeout(function() {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                            $rootScope.addingDeviceImei = false;
                            $('#addNextGenImeiModal').modal('hide');
                        });
                    }, 2000);
                } else {
                    $rootScope.addingDeviceImei = false;
                }
            });

            // console.log(imei,'IMEI in submit');
            $('#addNextGenImeiModal').modal('hide');
        }

        // ==================================================================================================================== //
        // FORMAT NEXT GEN PRODUCT NAME ++++++++++++++++=========================================================================== //
        $rootScope.formatNextGenGadgetCoverName = function(coverName, paymentPeriod){

            console.log(coverName,'in gadget cover name')

            var coverNameParts = [];

            if(coverName == 'essential'){
                return 'Essential';
            }

            if(coverName == 'essentials'){
                return 'Essentials';
            }

            if(coverName == 'premium'){

                if(paymentPeriod == 'Annual'){
                    return 'Premium Annual';
                }

                return 'Premium Annual Payable Monthly';

            }

            if(coverName == 'ultimate'){

                if(paymentPeriod == 'Annual'){
                    return 'Ultimate Annual';
                }

                return 'Utlimate Annual Payable Monthly';

            }

            if(coverName.startsWith('premium-') == true){

                coverNameParts = coverName.split('-');

                if(paymentPeriod == 'Annual'){
                    return 'Premium '+coverNameParts[1]+' Annual';
                }

                return 'Premium '+coverNameParts[1]+' Monthly Rolling';

            }


            if(coverName.startsWith('ultimate-') == true){

                coverNameParts = coverName.split('-');

                if(paymentPeriod == 'Annual'){
                    return 'Ultimate '+coverNameParts[1]+' Annual';
                }

                return 'Utlimate '+coverNameParts[1]+' Monthly Rolling';

            }





        }

        // ==================================================================================================================== //
        // OPENS CONFIRM WITHDRAWAL MODAL =========================================================================== //
        $rootScope.openCashpotWithdrawalModal = function(customer_id, firstname, surname) {

            $rootScope.createWithdrawal = {};
            $rootScope.createWithdrawal.customer_id = customer_id;
            $rootScope.createWithdrawal.firstname = firstname;
            $rootScope.createWithdrawal.surname = surname;
            $('#addCashpotWithdrawalModal').modal('show');
        }

        // ==================================================================================================================== //
        // CLOSES ADD IMEI MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeCashpotWithdrawalModal = function() {
            $('#addCashpotWithdrawalModal').modal('hide');

        }

        // ==================================================================================================================== //
        // OPENS ADD IMEI MODAL =========================================================================== //
        $rootScope.submitCashpotWithdrawalModal = function(customer_id, amount) {

            var dataToSend = { customerId: customer_id, amount: amount }
            $rootScope.createWithdrawal.inProgress = true;
            $rootScope.withdrawalError = null;
            $rootScope.withdrawalSuccess = null;

            apiService.request('POST', 'https://api.gonextgen.co.uk/cashpot/withdrawal/confirm?authorization=pvuH0EroHS-9XIiRXy3aR-n32HFzmyAQ', {}, dataToSend).then(function(response) {

                    if (response.status == 200) {
                        $rootScope.nudgeCustomerSuccessful = true;
                        $scope.callCustomerDetails(customer_id);
                        $timeout(function() {
                            $rootScope.createWithdrawal.inProgress = false;
                            $rootScope.withdrawalSuccess = true;
                            $('#addCashpotWithdrawalModal').modal('hide');

                        }, 2000);

                    }

                    if (response.status == 400) {


                    }
                })
                .catch((error) => {

                    console.log(error, 'response')
                    console.log('withdrawal error')
                    $timeout(function() {
                        $rootScope.createWithdrawal.inProgress = false;
                        $rootScope.withdrawalError = error;
                    }, 2000);

                });


        }

        // ==================================================================================================================== //
        // DISPLAY EMAIL CUSTOMER MODAL ++++++++++++++++=========================================================================== //
        $rootScope.showEmailCustomerModal = function(policy) {

           console.log(policy)

           console.log($scope.clientConfig.admins,'rootscope to send')



            $rootScope.customerServicePolicyCode = policy.policy_code;
            console.log($rootScope.customerServicePolicyId,'$rootScope.customerServicePolicyId');
            $rootScope.customerEmail = {};
            $rootScope.selectedTopic = {};
            $rootScope.chosenEmail = {};
            $rootScope.emailPayload = {audit_data: '',diary_data:'',diary_date:'',custom_text:''};
            

            apiService.request('GET', 'https://api.gonextgen.co.uk/customer-service/'+policy.policy_code+'?authorization=pvuH0EroHS-9XIiRXy3aR-n32HFzmyAQ', {
                
            }).then(function(response) {
                if (response.status == 200) {
                    console.log(response,'response')
                    $rootScope.customerEmail.config = response;

                    console.log($rootScope.customerEmail,'Config')

                    if(policy.name == 'Phone Insurance'){
                        $rootScope.customerEmail.policyName = 'Gadget'
                    }
                    else
                    {
                        $rootScope.customerEmail.policyName = 'Cycle'
                    }
                    
                    $rootScope.customerEmail.products = _.filter($rootScope.customerEmail.config, email => email.product === $rootScope.customerEmail.policyName);
                    $rootScope.customerEmail.topics = _.uniq($rootScope.customerEmail.products, email => email.topic);
                    console.log($rootScope.customerEmail.topics,'topics');
                    // $rootScope.customerEmail.type = '';

                    $('#nextgenEmailCustomerModal').modal('show');
                    

                }
            });

            

            
        }

        $rootScope.selectedTopicType = function(topic) {

            console.log(topic,'$rootScope.selectedTopic');

            $rootScope.customerEmail.customerEmails = _.filter($rootScope.customerEmail.products, email => email.topic === topic && email.product === $rootScope.customerEmail.policyName);

            console.log($rootScope.customerEmail.customerEmails,'selected topic');
        }


        $rootScope.selectedEmailType = function(emailId) {

            console.log(emailId,'selectedEmail')

            $rootScope.chosenEmail = _.filter($rootScope.customerEmail.products, email => email.id === emailId);

            $rootScope.chosenEmail[0].admin = $scope.adminId

            $rootScope.chosenEmail[0].diary_date = new Date($rootScope.chosenEmail[0].diary_date);
            $rootScope.chosenEmail[0].diary_time = $rootScope.chosenEmail[0].diary_date;

            console.log($rootScope.chosenEmail,'chosen email')
        }


        $rootScope.closeCustomerServiceModal = function() {
            $('#nextgenEmailCustomerModal').modal('hide');

        }


        $rootScope.submitCustomerServiceForm = function(target){

            

            var dataToSend = {
                id: $rootScope.chosenEmail[0].id,
                custom_text: $rootScope.chosenEmail[0].custom_text,
                diary_text: $rootScope.chosenEmail[0].diary_data,
                audit_text: $rootScope.chosenEmail[0].audit_data,
                diary_date: $rootScope.chosenEmail[0].diary_date,
                diary_time: $rootScope.chosenEmail[0].diary_time,
                target: target,
                policy: $rootScope.customerServicePolicyCode,
                admin: $rootScope.chosenEmail[0].admin,
                token: $scope.token
            }

            console.log(dataToSend,'data to send')

            apiService.request('POST', 'https://api.gonextgen.co.uk/customer-service?authorization=pvuH0EroHS-9XIiRXy3aR-n32HFzmyAQ', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    
                    if(target == 'customer'){
                        swal({
                            title: 'Email Sent to Customer',
                            timer: 3000,
                            type: 'success',
                            showConfirmButton: false
                        });

                        $rootScope.closeCustomerServiceModal();

                    }
                    else{
                        swal({
                            title: 'Test email sent to hello@gonextgen.co.uk',
                            timer: 3000,
                            type: 'success',
                            showConfirmButton: false
                        });
                    }

                
            };

        });

        }


        // ==================================================================================================================== //
        // SUBMIT EDIT MARKETPLACE MODAL ++++++++++++++++=========================================================================== //
        $rootScope.submitEditMarketplaceProfile = function(profile) {

            apiService.request('PUT', '/provider/' + profile.id + '/profile', {}, profile).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editMarketplaceProfileSuccess = true;
                    $timeout(function() {
                        $rootScope.editMarketplaceProfile = null;
                        $rootScope.editMarketplaceProfileSuccess = false;
                        $('#editMarketplaceProfileModal').modal('hide');
                        apiService.request('GET', '/provider').then(function(response) {
                            var currentClient = {};
                            $rootScope.clientConfig = response;
                            currentClient.name = $rootScope.clientConfig.name;
                            currentClient.id = $rootScope.clientConfig.id;
                            currentClient.products = $rootScope.clientConfig.products;
                            currentClient.insurers = $rootScope.clientConfig.insurers;
                            currentClient.admins = $rootScope.clientConfig.admins;
                            currentClient.shortcode = $rootScope.clientConfig.shortcode;
                            currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                            currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                            currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                            currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                            currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                            currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                            currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                            if ($rootScope.clientConfig.clients) {
                                $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                $rootScope.clientsAll.unshift(currentClient);
                            } else {
                                $rootScope.clientsAll = [];
                                $rootScope.clientsAll.push(currentClient);
                            }
                            //BUILD MARKETPLACE PROFILE
                            $rootScope.marketplaceProfile.id = $rootScope.clientConfig.id;
                            $rootScope.marketplaceProfile.contact_email = $rootScope.clientConfig.contact_email;
                            $rootScope.marketplaceProfile.status = $rootScope.clientConfig.status;
                            $rootScope.marketplaceProfile.speciality = $rootScope.clientConfig.speciality;
                            $rootScope.marketplaceProfile.founded = $rootScope.clientConfig.founded;
                            $rootScope.marketplaceProfile.profile_url = $rootScope.clientConfig.profile_url;
                            $rootScope.marketplaceProfile.profile_text = $rootScope.clientConfig.profile_text;
                            $rootScope.marketplaceProfile.handle = $rootScope.clientConfig.handle;
                            $rootScope.marketplaceProfile.function = $rootScope.clientConfig.function;
                            $rootScope.marketplaceProfile.logo_black_background = $rootScope.clientConfig.logo_black_background;
                            $rootScope.marketplaceProfile.logo_black_background_preview = $rootScope.clientConfig.logo_black_background;
                            $rootScope.marketplaceProfile.logo_grey_background = $rootScope.clientConfig.logo_grey_background;
                            $rootScope.marketplaceProfile.logo_grey_background_preview = $rootScope.clientConfig.logo_grey_background;
                            $rootScope.marketplaceProfile.logo_avatar = $rootScope.clientConfig.logo_avatar;
                            $rootScope.marketplaceProfile.logo_avatar_preview = $rootScope.clientConfig.logo_avatar;

                        });
                    }, 2000);
                }
            });
        }

        $rootScope.previousDocs = function(policy, documentIndex, event) {
            event.preventDefault();
            swal({
                title: "Are you sure you want to download this document",
                text: "This is a document from an old version of this policy",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, download old document",
                closeOnConfirm: true
            }).then((selection) => {
                window.open($rootScope.apiEndpoint + '/policy/' + policy.id + /deprecated-document/ + policy.additional_documents[parseInt(documentIndex)].version + '/' + policy.additional_documents[parseInt(documentIndex)].filename + '?authorization=' + $scope.token, '_blank');
            }).catch(swal.noop);
        }

        $rootScope.nudgeCustomerModal = function(customerDetails) {

            console.log('Customer Details', customerDetails);

            $rootScope.nudgeCustomer = new Object;
            $rootScope.nudgeCustomer.id = customerDetails.details.id;

            //$scope.nudgeCustomer.id = customerDetails.details.id;

            $('#nudgeCustomerModal').modal('show');
        }

        $rootScope.resetNudgeOptions = function() {
            $rootScope.nudgeCustomer.options = null
        }


        $rootScope.closeNudgeCustomerModal = function() {
            $('#nudgeCustomerModal').modal('hide');
        }

        // ==================================================================================================================== //
        // ADDING AN DOCUMENT TO A ADD PRODUCT ================================================================================ //
        $rootScope.addNudgeAttachment = function() {
            if (!$rootScope.nudgeCustomer.attachedDocument) {
                $rootScope.nudgeCustomer.attachedDocument = [];
            }
            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    //container: 'window',
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    //set picked image url to the profileImage scope
                    var dataToPush = {
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    $rootScope.nudgeCustomer.attachedDocument.push(dataToPush);
                    $rootScope.$apply();
                },
                function(FPError) {
                    ////console.log('Error message', FPError.toString());
                }
            );
        }

        // ==================================================================================================================== //
        // REMOVE A DOCUMENT THAT HAS BEEN ADDED ============================================================================== //
        $rootScope.removeNudgeAttachment = function(index) {
            swal({
                title: "Are you sure you want to delete this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                $rootScope.nudgeCustomer.attachedDocument.splice(index, 1);
                $rootScope.$apply();
            }).catch(swal.noop);

        }

        $rootScope.sendNudgeToCustomer = function(customerMessage) {

            var dataToSend = {
                id: customerMessage.id,
                message: customerMessage.message,
                cc: customerMessage.copyIn,
                policyCode: customerMessage.policy,
                option: customerMessage.options,
                attachments: customerMessage.attachedDocument,
                outboundAddress: customerMessage.outboundAddress
            }

            apiService.request('POST', '/customer/nudge', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.nudgeCustomerSuccessful = true;
                    $timeout(function() {
                        $('#nudgeCustomerModal').modal('hide');
                        $rootScope.nudgeCustomerSuccessful = false;
                    }, 2000);
                }
            });
        }

        //if there is an item in sessionStorage called previousId set it to $scope.previousId
        if (sessionStorage.getItem('previousId')) {
            $scope.previousId = JSON.parse(sessionStorage.getItem('previousId'));
        }

        //when the 'Expand to view profile' dropdown is clicked, the details are fetched and cached
        $scope.callCustomerDetails = function(customerId) {
            apiService.request('GET', '/customer/' + customerId, {
                headers: {
                    'X-Authorization': $scope.token
                },
            }).then(function(response) {
                if (response.status == 200) {
                    $rootScope.customerResults = response;
                }
            });
        }

        //called when a customer record is clicked after a search
        $scope.customerPage = function(customer, reload) {

            //open new object to take the temp data for the search to display on the customer page
            $rootScope.customerResults = new Object;

            //$rootScope.customerResults.customerId = new Object;
            $rootScope.customerResults.details = {
                id: customer.id,
                firstname: customer.firstname,
                surname: customer.surname,
                email: customer.email,
                security_question: customer.security_question,
                security_answer: customer.security_answer
            }

            //if there isn't a sessionStorage item called previousId then set one with the customer search data
            sessionStorage.setItem('previousId', JSON.stringify($rootScope.customerResults.details));

            //if there is sessionStorage item then set its contents to $scope.previousId
            $scope.previousId = JSON.parse(sessionStorage.getItem('previousId'));

            console.log($scope.previousId, 'Previous Id');

            if (reload == false) {

                //go to the customer route page
                $state.go('app.customer');

            }

            //scroll back up to the top of the customer page when navigated to
            $(".customer-container").animate({ scrollTop: 0 }, 0);

            // POLICIES
            apiService.request('GET', '/customer/' + customer.id + '/policies').then(function(response) {
                if (response.status == 200) {
                    $rootScope.products = response;
                }
            });

            // QUOTES
            apiService.request('GET', '/customer/' + customer.id + '/quotes').then(function(response) {
                if (response.status == 200) {
                    
                    $rootScope.quotes = response;
                    var i;
                    for (i = 0; i < $rootScope.quotes.length; i++) {

                        if ($rootScope.quotes[i].payload != null) {
                            //console.log('$rootScope.quotes[i].payload',JSON.parse($rootScope.quotes[i].payload))
                            $rootScope.quotes[i].payload = JSON.parse($rootScope.quotes[i].payload)
                            //$rootScope.quotes[i].test = 'foo'
                        }
                    }
                    
                    console.log($rootScope.quotes)

                }
            });

            // THIRD PARTY PRODUCTS
            // POLICIES
            apiService.request('GET', '/customer/' + customer.id + '/thirdparty-policies').then(function(response) {
                if (response.status == 200) {
                    $rootScope.thirdpartyProducts = response;
                }
            });

            // REMINDERS
            apiService.request('GET', '/reminder/' + customer.id).then(function(response) {
                if (response.status == 200) {
                    $rootScope.reminders = response;
                }
            });

            // BREACHES
            apiService.request('GET', '/breaches/' + customer.id).then(function(response) {
                if (response.status == 200) {
                    $rootScope.breaches = response;
                    var i;
                    for (i = 0; i < $rootScope.breaches.length; i++) {
                        $rootScope.breaches[i].text_breaches_json = JSON.parse($rootScope.breaches[i].text_breaches_json);
                    }
                }
            });

            // AUDIT TRAIL
            apiService.request('GET', '/audit/' + customer.id).then(function(response) {
                if (response.status == 200) {
                    $rootScope.audit = response;
                }
            });


            apiService.request('GET', '/customer/' + customer.id + '/yoti').then(function(response) {
                if (response.status == 200) {
                    $rootScope.yoti = response;
                }
            });
        }

        $scope.getProductDetails = function(product, index) {
            // console.log('Product details', product);
        }


        $scope.getQuoteDetails = function(quote, index) {
            // console.log('Quote details', quote);
        }

        $rootScope.showEmail = function(hash, index) {
            $rootScope.quotes[index].inbound_emails[0].src = $sce.trustAsResourceUrl($rootScope.quotes[index].inbound_emails[0].hash)
        }

        $rootScope.hideEmail = function(hash, index) {
            $rootScope.quotes[index].inbound_emails[0].src = ''
        }

        // RESEND CUSTOMER WELCOME EMAIL
        $scope.resendEmail = function(customerId) {
            //console.log('Customer ID', customerId);
            $scope.resendingEmail = true;
            var dataToSend = {
                id: customerId.id
            }
            apiService.request('POST', '/customer/resendwelcome', {}, dataToSend).then(function(response) {
                //console.log('Resent customer welcome email', response); 
                if (response.status == 200) {
                    swal({
                        title: 'Customer email sent',
                        timer: 3000,
                        type: 'success',
                        showConfirmButton: false
                    });
                } else {
                    $scope.resendingEmail = false;
                }

                $scope.resendingEmail = false;
            });
        }


        //SEND YOTI EMAIL
        $scope.sendYoti = function(customerId) {
            //console.log('Customer ID', customerId);
            $scope.sendingYoti = true;
            var dataToSend = {
                id: customerId.id
            }
            apiService.request('POST', '/customer/sendyoti', {}, dataToSend).then(function(response) {
                //console.log('Resent customer welcome email', response); 
                if (response.status == 200) {
                    swal({
                        title: 'Yoti Nudge Sent',
                        timer: 3000,
                        type: 'success',
                        showConfirmButton: false
                    });
                } else {
                    $scope.sendingYoti = false;
                }
                $scope.sendingYoti = false;
            });
        }



        $scope.generateReport = function(report) {

            var startDate = moment(report.start).format('YYYY/MM/DD');
            var endDate = moment(report.end).format('YYYY/MM/DD');


            window.open($rootScope.apiEndpoint + '/report/policy/' + report.product + '?start=' + startDate + '&end=' + endDate + '&authorization=' + $scope.token, '_blank');

            // $http.get($scope.api+'/report/'+report.product+'?start='+startDate+'&end='+endDate).then(function(response){
            //     if(response.status == 200) {
            //         console.log('Report response', response);
            //         //window.open( $scope.api+'/report/'+report.product+'?start='+startDate+'&end='+endDate , '_blank');
            //     }
            // });
        }

        $scope.generateCustomerReport = function(report) {
            // console.log('Customer Report data',report);
            var startDate = moment(report.start).format('YYYY/MM/DD');
            var endDate = moment(report.end).format('YYYY/MM/DD');
            console.log($rootScope, 'Rootscore in generateCustomerReport');
            if (report.customer_client == null) {
                var client = $rootScope.clientConfig.id;
            } else {
                var client = report.customer_client;
            }
            // console.log('Formatted start date', startDate);
            // console.log('Formatted end date', endDate);

            console.log(report, 'Report before generateCustomerReport');

            window.open($rootScope.apiEndpoint + '/report/customer/' + client + '?start=' + startDate + '&end=' + endDate + '&authorization=' + $scope.token, '_blank');

            // $http.get($scope.api+'/report/'+report.product+'?start='+startDate+'&end='+endDate).then(function(response){
            //     if(response.status == 200) {
            //         console.log('Report response', response);
            //         //window.open( $scope.api+'/report/'+report.product+'?start='+startDate+'&end='+endDate , '_blank');
            //     }
            // });
        }

        $scope.generateRewardsReport = function(report) {
            // console.log('Rewards Report data',report);
            var startDate = moment(report.start).format('YYYY/MM/DD');
            var endDate = moment(report.end).format('YYYY/MM/DD');
            // console.log('Formatted start date', startDate);
            // console.log('Formatted end date', endDate);

            window.open($rootScope.apiEndpoint + '/report/rewards?start=' + startDate + '&end=' + endDate + '&authorization=' + $scope.token, '_blank');

        }


        $scope.generateIntroductionsReport = function(report) {
            // console.log('Rewards Report data',report);
            var startDate = moment(report.start).format('YYYY/MM/DD');
            var endDate = moment(report.end).format('YYYY/MM/DD');
            // console.log('Formatted start date', startDate);
            // console.log('Formatted end date', endDate);

            window.open($rootScope.apiEndpoint + '/report/introductions?start=' + startDate + '&end=' + endDate + '&authorization=' + $scope.token, '_blank');

        }

        $scope.editPolicy = function(product) {
            $('#editPolicyModal').modal('show');
            // console.log('Product to be editted', product);
            $rootScope.editPolicy = {};
            $rootScope.editPolicy = product;
            $rootScope.editPolicy.start_date = new Date(moment(product.start_date).add(2, 'hours'));
            $rootScope.editPolicy.end_date = new Date(moment(product.end_date).add(2, 'hours'));
        }

        $('#editPolicyModal').on('hidden.bs.modal', function(e) {
            $rootScope.closeEditPolicyModal();
        });

        $rootScope.closeEditPolicyModal = function() {
            $('#editPolicyModal').modal('hide');
            $rootScope.editPolicy = null;
            apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                if (response.status == 200) {
                    $rootScope.products = response;
                }
            });
        }

        $rootScope.submitEditPolicy = function(policy) {
            var dataToSend = {
                    'id': parseInt($scope.previousId.id),
                    'data': policy
                }
                // console.log('Data to send to edit policy', dataToSend);
            apiService.request('PUT', '/policy/' + policy.id, {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editPolicySuccessful = true;
                    $timeout(function() {
                        product = {};
                        $rootScope.editPolicySuccessful = false;
                        $('#editPolicyModal').modal('hide');
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                        });
                    }, 2000);
                }
            });
        }

        $rootScope.addEditPolicyAttachment = function() {
            if (!$rootScope.editPolicy.attachedDocument) {
                $rootScope.editPolicy.attachedDocument = [];
            }
            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    //container: 'window',
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    ////console.log('Blob', Blob);
                    //set picked image url to the profileImage scope
                    var dataToPush = {
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    $rootScope.editPolicy.attachedDocument.push(dataToPush);
                    $rootScope.$apply();
                    ////console.log('Claim object after push', $rootScope.editPolicy);
                },
                function(FPError) {
                    ////console.log('Error message', FPError.toString());
                }
            );
        }

        $rootScope.removeEditPolicyAttachment = function(index) {
            swal({
                title: "Are you sure you want to remove this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, remove",
                closeOnConfirm: true
            }).then((selection) => {
                $rootScope.editPolicy.attachedDocument.splice(index, 1);
                $rootScope.$apply();
            }).catch(swal.noop);

        }

        $scope.deleteThirdPartyProductAttachment = function(index, product) {

            swal({
                title: "Are you sure you want to delete this attachment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                apiService.request('DELETE', '/policy/thirdparty/' + product.id + '/document/' + product.additional_documents[index].filename).then(function(response) {
                    ////console.log('Response', response);
                    apiService.request('GET', '/customer/' + product.customer_id + '/thirdparty-policies').then(function(response) {
                        $rootScope.thirdpartyProducts = response;
                    });
                });

            }).catch(swal.noop);
        }

        $scope.deleteNonThirdPartyProductAttachment = function(index, product) {


            swal({
                title: "Are you sure you want to delete this attachment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                apiService.request('DELETE', '/policy/' + product.id + '/document/' + product.additional_documents[index].filename).then(function(response) {

                    apiService.request('GET', '/customer/' + product.customer_id + '/policies').then(function(response) {

                        $rootScope.products = response;
                    });
                });

            }).catch(swal.noop);
        }

        $scope.paymentStatusChanged = function(product) {
            // console.log('Product information', product);
            swal({
                title: "Are you sure you want to update the payment status?",
                //text: "The customer will be notified of this change",   
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, change payment status",
                cancelButtonText: "No, keep current status",
                closeOnConfirm: true
            }).then((confirm) => {
                if (confirm) {
                    var dataToSend = {
                        policy_id: product.id,
                        payment_method: product.payment_method
                    }
                    apiService.request('POST', '/policy/payment', {}, dataToSend).then(function(response) {
                        // console.log('Update payment status response', response);
                        if (response.status == 200) {
                            apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                                $rootScope.products = response;
                            });
                        }
                    });
                } else { // if the cancel button is clicked, perform the below task
                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                        if (response.status == 200) {
                            $rootScope.products = response;
                        }
                    });
                }
            }).catch(swal.noop);
        }

        // AUDIT TRAIL REQUEST FOR THE ALL ADMIN TRAIL ON THE SEARCH PAGE
        apiService.request('GET', '/audit/staff').then(function(response) {
            if (response.status == 200) {
                $scope.staffAudit = response;
            }
        });
        // FUNCTION CALL FOR THE ALL ADMIN AUDIT TRAIL ON THE SEARCH PAGE
        $scope.staffAuditDates = function(staffAuditRange) {
            var startDate = moment(staffAuditRange.start).format('DD/MM/YYYY');
            var endDate = moment(staffAuditRange.end).format('DD/MM/YYYY');
            apiService.request('GET', '/audit/staff?start=' + startDate + '&end=' + endDate).then(function(response) {
                if (response.status == 200) {
                    $scope.staffAudit = response;
                }
            });
        }

        // FUNCTIONS FOR THE EDITING OF CUSTOMER PROFILE INFORMATION FROM THE CUSTOMER PAGE
        $rootScope.openEditCustomerProfileModal = function(customerDetails) {
            //open the modal and initialise the object
            $('#editCustomerProfileModal').modal('show');
            // console.log('Customer details', customerDetails.details);
            $rootScope.editCustomerProfile = customerDetails.details;
            $rootScope.editCustomerProfile.message = null; //will matt do this in the backend?
        }

        $rootScope.closeEditCustomerProfileModal = function() {
            //close the modal and set the object to null
            $('#editCustomerProfileModal').modal('hide');
            $rootScope.editCustomerProfile = null;
        }

        $rootScope.submitCustomerProfileEdit = function(newCustomerDetails) {
            // console.log('New Customer Details', newCustomerDetails);
            var dataToSend = {
                    details: newCustomerDetails
                }
                // console.log('Data to send', dataToSend);
            apiService.request('PUT', '/customer/profile', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editCustomerProfileSuccessful = true;
                    $timeout(function() {
                        $rootScope.editCustomerProfileSuccessful = false;
                        $('#editCustomerProfileModal').modal('hide');
                    }, 2000);
                }
            });
        }


        // ==================================================================================================================== //
        // OPENS ADD PRODUCT MODAL AND MAKES OBJECT =========================================================================== //
        $scope.addProduct = function() {

            $rootScope.addProduct = {};
            $rootScope.addProductSuccessful = false;
            //$rootScope.addProduct.productStart = new Date(); //this is optional so don't set up a date
            $rootScope.addProduct.productExpiry = new Date();
            $('#addProductModal').modal('show');
            $rootScope.format = 'dd/MM/yyyy';
            $rootScope.addProduct.premiumBilling = 'annual';
        }

        // ==================================================================================================================== //
        // CLOSES ADD PRODUCT MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeAddProductModal = function() {
            $('#addProductModal').modal('hide');
        }

        // ==================================================================================================================== //
        // ADDING AN DOCUMENT TO A ADD PRODUCT ================================================================================ //
        $rootScope.addAddProductAttachment = function() {

            if (!$rootScope.addProduct.attachedDocument) {
                $rootScope.addProduct.attachedDocument = [];
            }
            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    //container: 'window',
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    ////console.log('Blob', Blob);
                    //set picked image url to the profileImage scope
                    var dataToPush = {
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    $rootScope.addProduct.attachedDocument.push(dataToPush);
                    $rootScope.$apply();

                },
                function(FPError) {
                    ////console.log('Error message', FPError.toString());
                }
            );
        }

        // ==================================================================================================================== //
        // REMOVE A DOCUMENT THAT HAS BEEN ADDED ============================================================================== //
        $rootScope.removeAddProductAttachment = function(index) {
            swal({
                title: "Are you sure you want to remove this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, remove",
                closeOnConfirm: true
            }).then((selection) => {
                $rootScope.addProduct.attachedDocument.splice(index, 1);
            }).catch(swal.noop);

        }

        // ==================================================================================================================== //
        // SUBMIT THE ADD PRODUCT FORM ======================================================================================== //
        $rootScope.submitAddProduct = function(addProduct) {


            $rootScope.updatingAddProduct = true;
            var dataToSend = {
                product: addProduct,
                userId: $scope.previousId.id,
            }
            apiService.request('POST', '/policy/thirdparty', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.addProductSuccessful = true;
                    $timeout(function() {
                        //product = {};
                        $rootScope.addProductSuccessful = false;
                        $('#addProductModal').modal('hide');
                        $rootScope.updatingAddProduct = false;
                        // POLICIES
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/thirdparty-policies').then(function(response) {
                            if (response.status == 200) {
                                $rootScope.thirdpartyProducts = response;
                            }
                        });
                    }, 2000);
                } else {
                    $rootScope.updatingAddProduct = false;
                }
            }).catch((error) => {
                $rootScope.addProductSuccessful = false;
                $rootScope.addProductFailedMessage = error;
                $rootScope.updatingAddProduct = false;
                $timeout(function() {
                    $rootScope.addProductFailed = false;
                    $rootScope.addProductFailedMessage = '';
                }, 3000);
            });
        }

        // ADDING AN DOCUMENT TO A THIRD PARTY PRODUCT ==================================================================================== //
        $rootScope.addThirdPartyProductAttachment = function(thirdpartyProduct) {

            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    //container: 'window',
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    ////console.log('Blob', Blob);
                    //set picked image url to the profileImage scope
                    $('.claim-attachment-btn').prop('disabled', true);
                    var dataToPush = {
                        // user_filename: Blob.filename,
                        // url: Blob.url,
                        // mimetype: Blob.mimetype,
                        // filename: Blob.key
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }

                    if (thirdpartyProduct.additional_documents == null) {
                        thirdpartyProduct.additional_documents = [];
                        thirdpartyProduct.additional_documents.push(dataToPush);
                    } else {
                        thirdpartyProduct.additional_documents.push(dataToPush);
                    }

                    apiService.request('POST', '/policy/thirdparty/' + thirdpartyProduct.id + '/document', {}, dataToPush).then(function(response) {
                        ////console.log('Response', response);
                        apiService.request('GET', '/customer/' + thirdpartyProduct.customer_id + '/thirdparty-policies').then(function(response) {

                            $rootScope.thirdpartyProducts = response;
                            $('.claim-attachment-btn').prop('disabled', false);
                        });
                    });

                },
                function(FPError) {
                    ////console.log('Error message', FPError.toString());
                }
            );
        }

        // ==================================================================================================================== //
        // ADDING AN DOCUMENT TO A PRODUCT ==================================================================================== //
        $rootScope.addProductAttachment = function(product) {

            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    //container: 'window',
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    //set picked image url to the profileImage scope
                    $('.claim-attachment-btn').prop('disabled', true);
                    var dataToPush = {
                        // user_filename: Blob.filename,
                        // url: Blob.url,
                        // mimetype: Blob.mimetype,
                        // filename: Blob.key
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    product.additional_documents.push(dataToPush);

                    apiService.request('POST', '/policy/' + product.id + '/document', {}, dataToPush).then(function(response) {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                            $('.claim-attachment-btn').prop('disabled', false);
                        });
                    });

                },
                function(FPError) {
                    ////console.log('Error message', FPError.toString());
                }
            );
        }

        // ==================================================================================================================== //
        // REMOVE A DOCUMENT THAT HAS BEEN ADDED ============================================================================== //
        $rootScope.removeProductAttachment = function(index, product) {

            swal({
                title: "Are you sure you want to delete this attachment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                apiService.request('DELETE', '/policy/' + product.id + '/document/' + product.additional_documents[index].id).then(function(response) {
                    ////console.log('Response', response);
                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                        $rootScope.products = response;
                    });
                });

            }).catch(swal.noop);
        }

        $rootScope.quoteStatusUpdate = function(id, status, quoteId) {


            if (status === null) {
                return;
            }

            if (status === '8') {
                $('#bindQuoteModal').modal('show');
                $rootScope.bindQuote = {};
                $rootScope.bindQuote.id = quoteId;


                var i = 0;
                for (i = 0; i < $rootScope.quotes.length; i++) {
                    if ($rootScope.quotes[i].id == quoteId) {
                        $rootScope.quotes[i].status = '5';
                    }
                }

            } else if (status === '3') { // quoted

                swal({
                        title: "Are you sure you want to update the status to quoted?",
                        text: "This will notify the customer immediately",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#149fba",
                        confirmButtonText: "Yes, update to quoted",
                        closeOnConfirm: true
                    })
                    .then((selection) => {

                        if (selection) {

                            var dataToSend = {
                                'status': status,
                                'id': quoteId
                            }

                            apiService.request('PUT', '/quote/status', {}, dataToSend).then(function(response) {
                                if (response.status == 200) {
                                    apiService.request('GET', '/customer/' + id + '/quotes').then(function(response) {
                                        $rootScope.quotes = response;
                                        var i = 0;
                                        for (i = 0; i < $rootScope.quotes.length; i++) {
                                            if ($rootScope.quotes[i].status != null) {
                                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                            }
                                        }
                                    });
                                }
                            });

                        } else {
                            apiService.request('GET', '/customer/' + id + '/quotes').then(function(response) {
                                $rootScope.quotes = response;
                                var i = 0;
                                for (i = 0; i < $rootScope.quotes.length; i++) {
                                    if ($rootScope.quotes[i].status != null) {
                                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                    }
                                }
                            });
                        }

                    })
                    .catch(swal.noop);



            } else if (status === '5') { // ordered

                swal({
                        title: "Are you sure you want to update the status to an ordered?",
                        text: "This will notify the customer immediately",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#149fba",
                        confirmButtonText: "Yes, update to ordered",
                        closeOnConfirm: true
                    })
                    .then((isConfirm) => {

                        if (isConfirm) {

                            var dataToSend = {
                                'status': status,
                                'id': quoteId
                            }

                            apiService.request('PUT', '/quote/status', {}, dataToSend).then(function(response) {
                                if (response.status == 200) {
                                    apiService.request('GET', '/customer/' + id + '/quotes').then(function(response) {
                                        $rootScope.quotes = response;
                                        var i = 0;
                                        for (i = 0; i < $rootScope.quotes.length; i++) {
                                            if ($rootScope.quotes[i].status != null) {
                                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                            }

                                        }
                                    });
                                }
                            });
                        } else {
                            apiService.request('GET', '/customer/' + id + '/quotes').then(function(response) {
                                $rootScope.quotes = response;
                                var i = 0;
                                for (i = 0; i < $rootScope.quotes.length; i++) {
                                    if ($rootScope.quotes[i].status != null) {
                                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                    }

                                }
                            });
                        }

                    })
                    .catch(swal.noop);



            } else {
                var dataToSend = {
                    'status': status,
                    'id': quoteId
                }
                apiService.request('PUT', '/quote/status', {}, dataToSend).then(function(response) {
                    if (response.status == 200) {
                        apiService.request('GET', '/customer/' + id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                            var i = 0;
                            for (i = 0; i < $rootScope.quotes.length; i++) {
                                if ($rootScope.quotes[i].status != null) {
                                    $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                }

                            }
                        });
                    }
                });
            }
        }

        $rootScope.addScheduleDocument = function() {
            if (!$rootScope.bindQuote.schedule) {
                $rootScope.bindQuote.schedule = {};
            }
            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    $rootScope.bindQuote.schedule = dataToPush;
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }
        $rootScope.removeScheduleDocument = function() {
            $rootScope.bindQuote.schedule = {};
        }

        $rootScope.addWordingDocument = function() {
            if (!$rootScope.bindQuote.wording) {
                $rootScope.bindQuote.wording = {};
            }
            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    $rootScope.bindQuote.wording = dataToPush;
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }
        $rootScope.removeWordingDocument = function() {
            $rootScope.bindQuote.wording = {};
        }

        $rootScope.addKeyfactsDocument = function() {
            if (!$rootScope.bindQuote.keyfacts) {
                $rootScope.bindQuote.keyfacts = {};
            }
            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    $rootScope.bindQuote.keyfacts = dataToPush;
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }
        $rootScope.removeKeyfactsDocument = function() {
            $rootScope.bindQuote.keyfacts = {};
        }


        $rootScope.addInvoiceDocument = function() {
            if (!$rootScope.bindQuote.invoice) {
                $rootScope.bindQuote.invoice = {};
            }
            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    $rootScope.bindQuote.invoice = dataToPush;
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }
        $rootScope.removeInvoiceDocument = function() {
            $rootScope.bindQuote.invoice = {};
        }

        $rootScope.addOtherDocument = function() {
            if (!$rootScope.bindQuote.documents) {
                $rootScope.bindQuote.documents = [];
            }
            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    $rootScope.bindQuote.documents.push(dataToPush);
                    $rootScope.$apply();
                },
                function(FPError) {
                    //console.log('Error message', FPError.toString());
                }
            );
        }
        $rootScope.removeOtherDocument = function(index) {
            swal({
                title: "Are you sure you want to delete this document from this option?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                delete $rootScope.bindQuote.documents[index];
                $rootScope.$apply();
            }).catch(swal.noop);
        }

        $rootScope.bindThisQuote = function(bindQuote) {

            $rootScope.updatingBind = true;
            apiService.request('PUT', '/quote/bind', {}, bindQuote).then(function(response) {
                if (response.status == 200) {
                    //$rootScope.working = false;
                    $('html, body').animate({
                        scrollTop: $(".customer-container").offset().top
                    }, 500);
                    $timeout(function() {
                        $('#bindQuoteModal').modal('hide');
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                            var i = 0;
                            for (i = 0; i < $rootScope.quotes.length; i++) {
                                if ($rootScope.quotes[i].status != null) {
                                    $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                }
                            }
                        });
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                        });
                        $rootScope.updatingBind = false;
                        $state.reload();
                    }, 2000);
                }





            }).catch((error) => {
                $rootScope.bindQuoteFailed = true;
                $rootScope.bindQuoteFailedMessage = error;
                $rootScope.updatingBind = false;
                $timeout(function() {
                    $rootScope.bindQuoteFailed = false;
                    $rootScope.bindQuoteFailedMessage = '';
                }, 3000);
            });
        }

        $('#bindQuoteModal').on('hidden.bs.modal', function(e) {
            //when the bind quote modal is closed (by clicking outside of the modal) make a call for the current quote settings
            apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                $rootScope.quotes = response.data.data;
                var i = 0;
                for (i = 0; i < $rootScope.quotes.length; i++) {
                    if ($rootScope.quotes[i].status != null) {
                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                    }
                }
            });
            $rootScope.updatingBind = false;
        });

        $rootScope.closeBindQuoteModal = function() {
            //the hide below will trigger the hidden.bs.modal call above
            $('#bindQuoteModal').modal('hide');
        }

        $scope.searchDatabase = function(value, filter) {
            if ($scope.search.filter == 'customers') {
                var filterLength = 2;
            } else {
                var filterLength = 6;
            }
            $scope.searching = true;
            if ($scope.noResultsFound) {
                $scope.noResultsFound = false;
            }
            if (value.length <= filterLength && value.length != 0) {
                $scope.searchMessage = 'The search term is too short - must be at least ' + (filterLength + 1) + ' characters';
                $scope.searching = false;
            } else if (value.length == 0) {
                $scope.clearSearch();
                $scope.searching = false;
            } else {
                $scope.searchMessage = '';



                apiService.request('GET', '/search/' + filter + '/?q=' + value, {
                    headers: {
                        'X-Authorization': $scope.token
                    }
                }).then(function(response) {
                    $scope.searchResults = response;
                    // console.log('Search results', $scope.searchResults);
                    if ($scope.searchResults.length == 0) {
                        $scope.noResultsFound = true;
                    }
                    $scope.searching = false;
                });




            }
        }

        $scope.clearSearch = function() {
            $scope.search.item = '';
            document.querySelector('.search-field').focus();
            if ($scope.searchResults && $scope.searchResults.length > 0) {
                $scope.searchResults = null;
            }
            $scope.noResultsFound = false;
        }

        $scope.orderOption = function(option) {

            var dataToSend = {
                'id': option.id,
                'status': 2
            }

            swal({
                    title: "Are you sure you want to order this?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, order",
                    closeOnConfirm: true
                })
                .then((selection) => {

                    apiService.request('PUT', '/quote/option/status', {}, dataToSend).then(function(response) {
                        // console.log('Response from creating customer', response);
                        if (response.status == 200) {
                            $timeout(function() {
                                apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                    $rootScope.quotes = response;
                                    // console.log('Quotes', $rootScope.quotes);
                                    var i = 0;
                                    for (i = 0; i < $rootScope.quotes.length; i++) {
                                        if ($rootScope.quotes[i].status != null) {
                                            $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                        }
                                    }
                                });
                            }, 2000);
                        }
                    });

                })
                .catch(swal.noop);
        }

        $scope.cancelOption = function(option) {
            var dataToSend = {
                'id': option.quote_id
            }

            swal({
                    title: "Are you sure you want to cancel this order?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, cancel",
                    closeOnConfirm: true
                })
                .then((selection) => {

                    apiService.request('POST', '/quote/cancel-order', {}, dataToSend).then(function(response) {
                        if (response.status == 200) {
                            $timeout(function() {
                                apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                    $rootScope.quotes = response;
                                    // console.log('Quotes', $rootScope.quotes);
                                    var i = 0;
                                    for (i = 0; i < $rootScope.quotes.length; i++) {
                                        if ($rootScope.quotes[i].status != null) {
                                            $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                        }
                                    }
                                });
                            }, 2000);
                        }
                    });

                })
                .catch(swal.noop);
        }

        $scope.reinstateOption = function(option) {
            swal({
                title: "Reinstate this quote?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, reinstate",
                cancelButtonText: "No, keep option rejected",
                closeOnConfirm: true
            }).then((selection) => {

                var dataToSend = {
                    'id': option.quote_id,
                    'status': 3
                }
                apiService.request('POST', '/quote/cancel-order', {}, dataToSend).then(function(response) {
                    ////console.log('Response from creating customer', response);
                    if (response.status == 200) {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                        });
                    }
                });
            }).catch(swal.noop);
        }

        $rootScope.updateAddPremiumTotal = function(premium, ipt, fee) {

            var pricesAdd = [premium, ipt, fee];
            var totalPriceAdd = 0;
            var i = 0;
            for (i = 0; i < pricesAdd.length; i++) {
                if (pricesAdd[i] != false && pricesAdd[i] != undefined) {
                    totalPriceAdd += parseFloat(pricesAdd[i]);
                }
            }

            $rootScope.addOption.price = totalPriceAdd.toFixed(2).toString();
        }
        $rootScope.updateEditPremiumTotal = function(premium, ipt, fee) {
            var pricesEdit = [premium, ipt, fee];
            var totalPriceEdit = 0;
            var i = 0;
            for (i = 0; i < pricesEdit.length; i++) {
                if (pricesEdit[i] != false) {
                    totalPriceEdit += parseFloat(pricesEdit[i]);
                }
            }
            $rootScope.editOption.price = totalPriceEdit.toFixed(2).toString();
        }
        $rootScope.editPolicyPremiumTotal = function(premium, ipt, fee) {
                var pricesEditPolicy = [premium, ipt, fee];
                var totalPriceEditPolicy = 0;
                var i = 0;
                for (i = 0; i < pricesEditPolicy.length; i++) {
                    if (pricesEditPolicy[i] != false && pricesEditPolicy[i] != undefined) {
                        totalPriceEditPolicy += parseFloat(pricesEditPolicy[i]);
                    }
                }
                $rootScope.editPolicy.price = totalPriceEditPolicy.toFixed(2).toString();
            }
            // ============================================================================================================= //
            // OPENS ADD PRODUCT MODAL AND MAKES OBJECT ==================================================================== //
        $rootScope.addOptionFunc = function(quoteId, length) {
            $rootScope.addOption = {};
            $rootScope.addOption.insurer = $rootScope.clientConfig.insurers[0];
            $rootScope.addOption.quoteId = quoteId;
            $rootScope.addOption.quotedBy = $scope.adminId;
            $rootScope.addOption.price = 0;
            // $rootScope.addOption.can_quote = 'Yes';
            $rootScope.addOptionSuccessful = false;
            $('#addOptionModal').modal('show');
        }

        //option to make the minimum date today's date
        $rootScope.minDate = new Date();

        $rootScope.addOptionPickerOptions = {
            maxDate: new Date(),
            showWeeks: false
        }

        // ============================================================================================================= //
        // CLOSES ADD PRODUCT MODAL ++++++++++++++++==================================================================== //
        $rootScope.closeAddOptionModal = function() {
                $('#addOptionModal').modal('hide');
                $rootScope.addOption = null;
            }
            // ========================================================================================================== //
            // SUBMIT THE ADD PRODUCT FORM ============================================================================== //
        $rootScope.submitAddOption = function(option) {

                apiService.request('POST', '/quote/option', {}, option).then(function(response) {

                    if (response.status == 200) {
                        //$rootScope.working = false;
                        $rootScope.addOptionSuccessful = true;
                        $timeout(function() {
                            $rootScope.addOptionSuccessful = false;
                            $('#addOptionModal').modal('hide');
                            apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                $rootScope.quotes = response;
                                var i = 0;
                                for (i = 0; i < $rootScope.quotes.length; i++) {
                                    if ($rootScope.quotes[i].status != null) {
                                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();

                                    }
                                }
                            });
                        }, 2000);

                    } else {
                        //$rootScope.working = false;
                    }
                    if (response.status == 400) {
                        $rootScope.addOptionFailed = true;
                        $rootScope.addOptionFailedMessage = response.message;
                        $timeout(function() {
                            $rootScope.addOptionFailed = false;
                            $rootScope.addOptionFailedMessage = '';

                        }, 2000);
                    }
                });
            }
            // ========================================================================================================== //
            // DELETE ON OPTION FROM THIS QUOTE ========================================================================= //
        $rootScope.deleteOption = function(option) {

                swal({
                        title: "Are you sure you want to delete this option?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#149fba",
                        confirmButtonText: "Yes, delete",
                        closeOnConfirm: true
                    })
                    .then((selection) => {

                        apiService.request('DELETE', '/quote/option/' + option.id).then(function(response) {
                            if (response.status == 200) {
                                apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                    $rootScope.quotes = response;
                                    var i = 0;
                                    for (i = 0; i < $rootScope.quotes.length; i++) {
                                        if ($rootScope.quotes[i].status != null) {
                                            $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                        }
                                    }
                                });
                            }
                        });

                    })
                    .catch(swal.noop);

            }
            // ========================================================================================================== //
            // ADDING AN DOCUMENT TO A ADD PRODUCT ====================================================================== //
        $rootScope.addAddOptionAttachment = function() {
                if (!$rootScope.addOption.documents) {
                    $rootScope.addOption.documents = [];
                }
                filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                        var dataToPush = {
                            filename: Blob[0].filename,
                            url: Blob[0].url,
                            mimetype: Blob[0].mimetype,
                            key: Blob[0].key
                        }
                        $rootScope.addOption.documents.push(dataToPush);
                        $rootScope.$apply();
                    },
                    function(FPError) {
                        //console.log('Error message', FPError.toString());
                    }
                );
            }
            // ========================================================================================================== //
            // REMOVE A DOCUMENT THAT HAS BEEN ADDED ==================================================================== //
        $rootScope.removeAddOptionAttachment = function(index) {
            swal({
                title: "Are you sure you want to delete this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                delete $rootScope.addOption.documents[index];
                $rootScope.$apply();
            }).catch(swal.noop);
        }

        $rootScope.editOptionFunction = function(option) {

            $rootScope.editOption = {};
            $rootScope.editOption = angular.copy(option);
            $rootScope.editOption.canQuote = angular.copy(option.can_quote);
            $rootScope.editOption.quotedBy = angular.copy(option.quoted_by);
            $rootScope.editOption.billingPeriod = angular.copy(option.billing_period);

            $rootScope.editOption.expiry = new Date(moment(option.expiry).add(12, 'hours'));

            $('#editOptionModal').modal('show');
        }

        $rootScope.submitEditOption = function(option) {
            apiService.request('PUT', '/quote/option', {}, option).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editOptionSuccessful = true;
                    $timeout(function() {
                        $rootScope.editOption = {};
                        $rootScope.editOptionSuccessful = false;
                        $('#editOptionModal').modal('hide');
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                            var i = 0;
                            for (i = 0; i < $rootScope.quotes.length; i++) {
                                if ($rootScope.quotes[i].status != null) {
                                    $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                }
                            }
                        });
                    }, 2000);
                }
            });
        }
        $rootScope.closeEditOptionModal = function() {
            $('#editOptionModal').modal('hide');
            $rootScope.editOption = null;
        }

        $rootScope.addEditOptionAttachment = function(option) {

            filepicker.pickAndStore(docFilepickerOptions, {}, function(Blob) {
                    $('.claim-attachment-btn').prop('disabled', true);
                    var dataToPush = {
                        filename: Blob[0].filename,
                        url: Blob[0].url,
                        mimetype: Blob[0].mimetype,
                        key: Blob[0].key
                    }
                    apiService.request('POST', '/quote/option/' + option.id + '/document', {}, dataToPush).then(function(response) {
                        $timeout(function() { $('.claim-attachment-btn').prop('disabled', false); }, 2000);
                        if (response.status == 200) {
                            $('#editOptionModal').modal('hide');
                            apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                $rootScope.quotes = response;
                                var i = 0;
                                for (i = 0; i < $rootScope.quotes.length; i++) {
                                    if ($rootScope.quotes[i].status != null) {
                                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                    }
                                }
                            });
                        }
                    });
                },
                function(FPError) {
                    // console.log('Error message', FPError);
                    $('.claim-attachment-btn').prop('disabled', false);
                }
            );
        }

        $rootScope.removeEditOptionAttachment = function(index, option) {
            swal({
                title: "Are you sure you want to delete this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                apiService.request('DELETE', '/quote/option/' + option.id + '/document/' + option.documents[index].filename).then(function(response) {
                    if (response.status == 200) {
                        $timeout(function() {
                            $('#editOptionModal').modal('hide');
                            apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                                $rootScope.quotes = response;
                                var i = 0;
                                for (i = 0; i < $rootScope.quotes.length; i++) {
                                    if ($rootScope.quotes[i].status != null) {
                                        $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                    }
                                }
                            });
                        }, 2000);
                    }
                });
            }).catch(swal.noop);
        }

        $rootScope.openNewQuoteModal = function(customerDetails, product) {
            // console.log('customerDetails', customerDetails);
            $rootScope.newQuote = {};
            $rootScope.newQuote.id = customerDetails.details.id;
            $rootScope.newQuote.email = customerDetails.details.email;
            $rootScope.newQuote.firstname = customerDetails.details.firstname;
            $rootScope.newQuote.surname = customerDetails.details.surname;
            if (product) {

                console.log(product,product)

                $rootScope.newQuote.insurance_product = product.id;
            }
            $('#newQuoteModal').modal('show');
        }
        $rootScope.closeNewQuoteModal = function() {
            $('#newQuoteModal').modal('hide');
        }


        $rootScope.createQuote = function(newQuote) {
            $rootScope.addingQuote = true;
            console.log(newQuote)
            var dataToSend = {
                'data': {
                    'id': newQuote.id,
                    'insurance_product': newQuote.insurance_product.id,
                    'email': newQuote.email,
                    'firstname': newQuote.firstname,
                    'surname': newQuote.surname,
                    'target_price': newQuote.target_price,
                    'deadline': newQuote.deadline,
                    'contact_number': newQuote.contact_number,
                    'internal': true,
                    'seller_reference': newQuote.seller_reference
                }
            }
            apiService.request('POST', '/quote/' + newQuote.insurance_product.id, {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $timeout(function() {
                        $('#newQuoteModal').modal('hide');
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                            var i = 0;
                            for (i = 0; i < $rootScope.quotes.length; i++) {
                                if ($rootScope.quotes[i].status != null) {
                                    $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                }
                            }
                            if ($rootScope.quotes.length == 0) {
                                $rootScope.noQuotes = true;
                            }
                        });
                        $rootScope.addingQuote = false;
                    }, 2000);
                } else {
                    $rootScope.addingQuote = false;
                }
            });
        }

        $rootScope.openNewCustomerModal = function() {

            $('#newCustomerModal').modal('show');
            $rootScope.newCustomer = {};
        }
        $rootScope.closeNewCustomerModal = function() {
            $('#newCustomerModal').modal('hide');
        }
        $rootScope.createCustomer = function(newCustomer) {
            //$rootScope.working = true;
            apiService.request('POST', '/customer', {}, newCustomer).then(function(response) {
                // console.log('Response from creating customer', response);
                // console.log('newCustomer', newCustomer);
                if (response.status == 200) {
                    $rootScope.addCustomerSuccessful = true;
                    //$rootScope.working = false;
                    $timeout(function() {
                        $('#newCustomerModal').modal('hide');
                        $rootScope.addCustomerSuccessful = false;
                        var customerData = {
                            id: response.customerId,
                            firstname: newCustomer.firstname,
                            surname: newCustomer.surname,
                            email: newCustomer.email
                        }
                        $scope.customerPage(customerData);
                    }, 2000);
                } else {
                    //$rootScope.working = false; 
                }
            });
        }

        $rootScope.revisePolicy = function(productId) {
            // console.log(productId);
            swal({
                title: "A new quote will be generated so that the MTA can be made",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Generate MTA quote",
                closeOnConfirm: true
            }).then((selection) => {
                var dataToSend = {
                    'id': productId
                }

                $('html, body').animate({
                    scrollTop: $("#quotesContainer").offset().top
                }, 500);

                apiService.request('POST', '/policy/' + productId + '/mta', {}, dataToSend).then(function(response) {
                    // console.log('Response', response);
                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                        $rootScope.quotes = response;
                        var i = 0;
                        for (i = 0; i < $rootScope.quotes.length; i++) {
                            if ($rootScope.quotes[i].status != null) {
                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                            }
                        }
                    });
                });
            }).catch(swal.noop);


            // swal({   
            //     title: "A new quote will be generated so that the customer's amendments can be made",   
            //     type: "warning",
            //     showCancelButton: true,   
            //     confirmButtonColor: "#149fba",   
            //     confirmButtonText: "Generate new quote",   
            //     closeOnConfirm: true 
            // })
            // .then((selection) => {

            //     if(selection){

            //         var dataToSend = {
            //             'id': productId
            //         }

            //         $('html, body').animate({
            //             scrollTop: $("#quotesContainer").offset().top
            //         }, 500);

            //         apiService.request('POST','/policy/requote', {}, dataToSend).then(function(response){
            //             // console.log('Response', response);
            //             apiService.request('GET', '/customer/'+$scope.previousId.id+'/quotes').then(function(response){
            //                 $rootScope.quotes = response;
            //                 var i = 0;
            //                 for(i = 0; i < $rootScope.quotes.length; i++){
            //                     if($rootScope.quotes[i].status != null){
            //                         $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
            //                     }
            //                 }
            //             });
            //         })
            //     }
            // })    
            // .catch(swal.noop);
        }

        $scope.deleteQuote = function(quote) {
            //console.log('Quote', quote);
            swal({
                    title: "Are you sure you want to delete this quote?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, delete",
                    closeOnConfirm: true
                })
                .then((selection) => {
                    //console.log('Quote', quote);
                    apiService.request('DELETE', '/quote/' + quote.id).then(function(response) {
                        //console.log('Response from delete quote', response);
                        //$rootScope.isCollapsed = false;
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                            $rootScope.quotes = response;
                            var i = 0;
                            for (i = 0; i < $rootScope.quotes.length; i++) {
                                //console.log($rootScope.quotes[i].status);
                                if ($rootScope.quotes[i].status != null) {
                                    $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                                }

                            }
                            if ($rootScope.quotes.length == 0) {
                                $rootScope.noQuotes = true;
                            }
                            //console.log('New quotes were fetched');
                        });
                        $state.reload();
                    });
                }).catch(swal.noop);

        }

        // ==================================================================================================================== //
        // OPENS settled claim MODAL AND MAKES OBJECT =========================================================================== //
        /*
         $scope.addSettledClaim = function(policy){
             console.log('add settled claim');
         
             $rootScope.addSettledClaim = {};
             $rootScope.addSettledClaim.id = product.id
             $rootScope.addSettledClaimSuccessful = false;
             $('#settledClaimModal').modal('show');
             
         }
         */
        // ==================================================================================================================== //
        // CLOSES cancel PRODUCT MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeAddSettledClaimModal = function() {
                $('#settledClaimModal').modal('hide');
            }
            // ==================================================================================================================== //
            // SUBMIT THE cancel PRODUCT FORM ======================================================================================== //
        $rootScope.submitAddSettledClaim = function(product) {
            $rootScope.updatingAddSettledClaim = true;
            var dataToSend = {
                'id': product.id,
                'date': product.date,
                'notes': product.notes
            }
            apiService.request('POST', '/claim/processed-claim', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $timeout(function() {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                            $rootScope.updatingCancelProduct = false;
                            $rootScope.updatingAddSettledClaim = false;
                            $('#settledClaimModal').modal('hide');
                        });
                    }, 2000);
                } else {
                    $rootScope.updatingAddSettledClaim = false;
                }
            });
        }


        // OPENS settled claim MODAL AND MAKES OBJECT =========================================================================== //
        /*
        $scope.editSettledClaim = function(product){
            console.log(product,'edit settled claim');
            $rootScope.editSettledClaim = {};
            $rootScope.editSettledClaim.id = product.id
            $rootScope.editSettledClaim.notes = product.claim_details
            $rootScope.editSettledClaim.date = new Date(product.claim_date);
            $rootScope.editSettledClaimSuccessful = false;
            $('#editSettledClaimModal').modal('show');
        }
        */
        // ==================================================================================================================== //
        // CLOSES cancel PRODUCT MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeEditSettledClaimModal = function() {
            $('#editSettledClaimModal').modal('hide');
        }
        $rootScope.submitEditSettledClaim = function(product) {
            $rootScope.updatingEditSettledClaim = true;
            var dataToSend = {
                'id': product.id,
                'date': product.date,
                'notes': product.notes
            }
            apiService.request('PUT', '/claim/processed-claim/' + dataToSend.id, {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $timeout(function() {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                            $rootScope.updatingEditSettledClaim = false;
                            $('#editSettledClaimModal').modal('hide');
                        });
                    }, 2000);
                } else {
                    $rootScope.updatingEditSettledClaim = false;
                }
            });
        }




        // ==================================================================================================================== //
        // OPENS cancel PRODUCT MODAL AND MAKES OBJECT =========================================================================== //
        $scope.cancelPolicy = function(product) {
                $rootScope.cancelProduct = {};
                $rootScope.cancelProduct.id = product.id
                $rootScope.cancelProductSuccessful = false;
                $('#cancelProductModal').modal('show');
            }
            // ==================================================================================================================== //
            // CLOSES cancel PRODUCT MODAL ++++++++++++++++=========================================================================== //
        $rootScope.closeCancelProductModal = function() {
                $('#cancelProductModal').modal('hide');
            }
            // ==================================================================================================================== //
            // SUBMIT THE cancel PRODUCT FORM ======================================================================================== //
        $rootScope.submitCancelProduct = function(product) {
            $rootScope.updatingCancelProduct = true;
            console.log(product,'cancel product')
            var dataToSend = {
                'id': product.id,
                'cancellation_reason': product.reason_for_cancellation,
                'cancellation_notes': product.notes,
                'cancellation_date': product.cancellation_date
            }
            apiService.request('POST', '/policy/cancel', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $timeout(function() {
                        apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                            $rootScope.products = response;
                            $rootScope.updatingCancelProduct = false;
                            $('#cancelProductModal').modal('hide');
                        });
                    }, 2000);
                } else {
                    $rootScope.updatingCancelProduct = false;
                }
            });
        }

        $scope.auditDates = function(auditRange, customerId) {
            var startDate = moment(auditRange.start).format('DD/MM/YYYY');
            var endDate = moment(auditRange.end).format('DD/MM/YYYY');
            apiService.request('GET', '/audit/' + $scope.previousId.id + '?start=' + startDate + '&end=' + endDate).then(function(response) {
                // console.log('Date range response', response);
                if (response.status == 200) {
                    $rootScope.audit = response;
                }
            });
        }

        $scope.format = 'dd/MM/yyyy';
        $scope.options = {
            maxDate: new Date(),
            showWeeks: false
        };


        // ==================================================================================================================== //
        // SUBMIT THE cancel PRODUCT FORM ======================================================================================== //
        $rootScope.acceptValuation = function(policy) {

            swal({
                    title: "Are you sure you want to accept the valuation provided by the user?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, accept",
                    closeOnConfirm: true
                })
                .then((selection) => {

                    var dataToSend = { status: 'approved' };
                    apiService.request('POST', '/policy/' + policy.id + '/valuation', {}, dataToSend).then(function(response) {

                        if (response.status == 200) {
                            $timeout(function() {
                                apiService.request('GET', '/customer/' + policy.customer_id + '/policies').then(function(response) {

                                    $rootScope.products = response;
                                    $rootScope.updatingAcceptValuation = false;
                                    $('#cancelAcceptValuationModal').modal('hide');
                                });
                            }, 2000);
                        } else {
                            $rootScope.updatingAcceptValuation = false;
                        }


                    });

                }).
            catch(swal.noop);

        }

        // ==================================================================================================================== //
        // REINSTATE THE POLICY ======================================================================================== //
        $rootScope.reinstatePolicy = function(policy) {

            swal({
                title: "Are you sure you want to reinstate the policy?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, reinstate the policy",
                closeOnConfirm: true
            })
            .then((selection) => {

                apiService.request('POST', '/policy/reinstate', {}, {'id':policy.id}).then(function(response) {

                    if (response.status == 200) {
                        $timeout(function() {
                            apiService.request('GET', '/customer/' + policy.customer_id + '/policies').then(function(response) {

                                $rootScope.products = response;
                                
                            });
                        }, 2000);
                    } else {
                        
                    }

                });

            })

        }




        $rootScope.valuationPending = function(policy) {

            swal({
                    title: "This will mark the valuation as pending, and send an email to the customer. Do you wish to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, continue",
                    closeOnConfirm: true
                })
                .then((selection) => {

                    var dataToSend = { status: 'pending' };
                    apiService.request('POST', '/policy/' + policy.id + '/valuation', {}, dataToSend).then(function(response) {

                        if (response.status == 200) {
                            $timeout(function() {
                                apiService.request('GET', '/customer/' + policy.customer_id + '/policies').then(function(response) {

                                    $rootScope.products = response;
                                    $rootScope.updatingAcceptValuation = false;
                                    $('#cancelAcceptValuationModal').modal('hide');
                                });
                            }, 2000);
                        } else {
                            $rootScope.updatingAcceptValuation = false;
                        }


                    });

                }).
            catch(swal.noop);

        }



        // ==================================================================================================================== //
        // CLIENTS ========================================================================================================== //

        $rootScope.openClientModal = function(client) {
            if (client) {
                $rootScope.clientModal = angular.copy(client);
            }
            $('#clientModal').modal('show');
        }
        $rootScope.closeClientModal = function() {
            $('#clientModal').modal('hide');
            $rootScope.clientModal = {};
        }
        $rootScope.submitClient = function(client) {

            if (client.id) {
                //put
                apiService.request('PUT', '/provider/' + client.id, {}, client).then(function(response) {
                    // console.log('Response from creating customer', response);
                    if (response.status == 200) {
                        $timeout(function() {
                            apiService.request('GET', '/provider').then(function(response) {
                                var currentClient = {};
                                $rootScope.clientConfig = response;
                                currentClient.name = $rootScope.clientConfig.name;
                                currentClient.id = $rootScope.clientConfig.id;
                                currentClient.products = $rootScope.clientConfig.products;
                                currentClient.insurers = $rootScope.clientConfig.insurers;
                                currentClient.admins = $rootScope.clientConfig.admins;
                                currentClient.shortcode = $rootScope.clientConfig.shortcode;
                                currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                                currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                                currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                                currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                                currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                                currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                                currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                                if ($rootScope.clientConfig.clients) {
                                    $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                    $rootScope.clientsAll.unshift(currentClient);
                                } else {
                                    $rootScope.clientsAll = [];
                                    $rootScope.clientsAll.push(currentClient);
                                }
                                $('#clientModal').modal('hide');
                            });
                        }, 2000);
                    }
                });
            } else {
                apiService.request('POST', '/provider', {}, client).then(function(response) {
                    //$rootScope.working = true;
                    if (response.status == 200) {
                        //$rootScope.working = false;
                        $rootScope.clientSuccessful = true;
                        $timeout(function() {
                            apiService.request('GET', '/provider').then(function(response) {
                                $rootScope.clientConfig = response;
                                var currentClient = {};
                                currentClient.name = $rootScope.clientConfig.name;
                                currentClient.id = $rootScope.clientConfig.id;
                                currentClient.products = $rootScope.clientConfig.products;
                                currentClient.insurers = $rootScope.clientConfig.insurers;
                                currentClient.admins = $rootScope.clientConfig.admins;
                                currentClient.shortcode = $rootScope.clientConfig.shortcode;
                                currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                                currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                                currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                                currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                                currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                                currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                                currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                                if ($rootScope.clientConfig.clients) {
                                    $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                    $rootScope.clientsAll.unshift(currentClient);
                                } else {
                                    $rootScope.clientsAll = [];
                                    $rootScope.clientsAll.push(currentClient);
                                }
                                $('#clientModal').modal('hide');
                            });
                        }, 2000);
                    } else {
                        //$rootScope.working = false;
                    }
                    if (response.status == 400) {
                        $rootScope.clientFailed = true;
                        $rootScope.clientFailedMessage = response.message;
                        $timeout(function() {
                            $rootScope.clientFailed = false;
                            $rootScope.clientFailedMessage = '';
                        }, 2000);
                    }
                });
            }
        }

        // ==================================================================================================================== //
        // CLIENT USERS ========================================================================================================== //

        $rootScope.openClientUsersModal = function(client) {
            $rootScope.clientUsers = angular.copy(client);
            $('#clientUsersModal').modal('show');
        }
        $rootScope.closeClientUsersModal = function() {
            $('#clientUsersModal').modal('hide');
            $rootScope.clientUsers = {};
        }
        $rootScope.submitClientUser = function(client) {
            var dataToSend = {
                firstname: client.firstname,
                surname: client.surname,
                email: client.email
            }

            apiService.request('POST', '/provider/' + client.id + '/admin', {}, dataToSend).then(function(response) {
                //$rootScope.working = true;
                if (response.status == 200) {
                    //$rootScope.working = false;
                    $rootScope.clientUserSuccessful = true;
                    $timeout(function() {
                        $rootScope.clientUserSuccessful = false;
                        $('#clientUsersModal').modal('hide');
                        apiService.request('GET', '/provider').then(function(response) {
                            $rootScope.clientConfig = response;
                            var currentClient = {};
                            currentClient.name = $rootScope.clientConfig.name;
                            currentClient.id = $rootScope.clientConfig.id;
                            currentClient.products = $rootScope.clientConfig.products;
                            currentClient.insurers = $rootScope.clientConfig.insurers;
                            currentClient.admins = $rootScope.clientConfig.admins;
                            currentClient.shortcode = $rootScope.clientConfig.shortcode;
                            currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                            currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                            currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                            currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                            currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                            currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                            currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                            if ($rootScope.clientConfig.clients) {
                                $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                $rootScope.clientsAll.unshift(currentClient);
                            } else {
                                $rootScope.clientsAll = [];
                                $rootScope.clientsAll.push(currentClient);
                            }
                        });
                    }, 2000);
                } else {
                    //$rootScope.working = false;
                }
                if (response.status == 400) {
                    $rootScope.clientUserFailed = true;
                    $rootScope.clientUserFailedMessage = response.message;
                    $timeout(function() {
                        $rootScope.clientUserFailed = false;
                        $rootScope.clientUserFailedMessage = '';
                    }, 2000);
                }
            });
        }
        $rootScope.removeClientUser = function(user) {

                swal({
                    title: "Are you sure you want to delete this user?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, delete",
                    closeOnConfirm: true
                }).then((selection) => {
                    apiService.request('DELETE', '/provider/admin/' + user.id).then(function(response) {
                        if (response.status == 200) {
                            $('#clientUsersModal').modal('hide');
                            apiService.request('GET', '/provider').then(function(response) {
                                $rootScope.clientConfig = response;
                                currentClient.name = $rootScope.clientConfig.name;
                                currentClient.id = $rootScope.clientConfig.id;
                                currentClient.products = $rootScope.clientConfig.products;
                                currentClient.insurers = $rootScope.clientConfig.insurers;
                                currentClient.admins = $rootScope.clientConfig.admins;
                                currentClient.shortcode = $rootScope.clientConfig.shortcode;
                                currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                                currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                                currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                                currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                                currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                                currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                                currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                                if ($rootScope.clientConfig.clients) {
                                    $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                    $rootScope.clientsAll.unshift(currentClient);
                                } else {
                                    $rootScope.clientsAll = [];
                                    $rootScope.clientsAll.push(currentClient);
                                }
                            });
                        }
                    });

                }).catch(swal.noop);
            }
            // ==================================================================================================================== //
            // CLIENT PRODUCTS ========================================================================================================== //
        $rootScope.openClientProductsModal = function(id, product) {
            $('#clientProductsModal').modal('show');
            $rootScope.clientProducts = {};
            if (product) {
                $rootScope.clientProducts = angular.copy(product);
            } else {
                $rootScope.clientProducts = {};
            }
            $rootScope.clientProducts.int_clients_id = angular.copy(id);
        }
        $rootScope.closeClientProductsModal = function() {
            $('#clientProductsModal').modal('hide');
            $rootScope.clientProducts = {};
        }
        $rootScope.submitClientProducts = function(product) {
            if (product.id) {

                apiService.request('PUT', '/provider/' + product.int_clients_id + '/product/' + product.id, {}, product).then(function(response) {
                    if (response.status == 200) {
                        $rootScope.clientProductsSuccessful = true;
                        $timeout(function() {
                            $rootScope.clientProducts = null;
                            $rootScope.clientProductsSuccessful = false;
                            $('#clientProductsModal').modal('hide');
                            apiService.request('GET', '/provider').then(function(response) {
                                $rootScope.clientConfig = response;
                                var currentClient = {};
                                currentClient.name = $rootScope.clientConfig.name;
                                currentClient.id = $rootScope.clientConfig.id;
                                currentClient.products = $rootScope.clientConfig.products;
                                currentClient.insurers = $rootScope.clientConfig.insurers;
                                currentClient.admins = $rootScope.clientConfig.admins;
                                currentClient.shortcode = $rootScope.clientConfig.shortcode;
                                currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                                currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                                currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                                currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                                currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                                currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                                currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                                if ($rootScope.clientConfig.clients) {
                                    $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                    $rootScope.clientsAll.unshift(currentClient);
                                } else {
                                    $rootScope.clientsAll = [];
                                    $rootScope.clientsAll.push(currentClient);
                                }
                            });
                        }, 2000);
                    }
                    if (response.status == 400) {
                        $rootScope.clientProductsFailed = true;
                        $rootScope.clientProductsFailedMessage = response.message;
                        $timeout(function() {
                            $rootScope.clientProductsFailed = false;
                            $rootScope.clientProductsFailedMessage = '';
                        }, 2000);
                    }
                });
            } else {
                apiService.request('POST', '/provider/' + product.int_clients_id + '/product', {}, product).then(function(response) {
                    //$rootScope.working = true;
                    if (response.status == 200) {
                        //$rootScope.working = false;
                        $rootScope.clientProductsSuccessful = true;
                        $timeout(function() {
                            $rootScope.clientProductsSuccessful = false;
                            $('#clientProductsModal').modal('hide');
                            apiService.request('GET', '/provider').then(function(response) {
                                $rootScope.clientConfig = response;
                                var currentClient = {};
                                currentClient.name = $rootScope.clientConfig.name;
                                currentClient.id = $rootScope.clientConfig.id;
                                currentClient.products = $rootScope.clientConfig.products;
                                currentClient.insurers = $rootScope.clientConfig.insurers;
                                currentClient.admins = $rootScope.clientConfig.admins;
                                currentClient.shortcode = $rootScope.clientConfig.shortcode;
                                currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                                currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                                currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                                currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                                currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                                currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                                currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                                if ($rootScope.clientConfig.clients) {
                                    $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                    $rootScope.clientsAll.unshift(currentClient);
                                } else {
                                    $rootScope.clientsAll = [];
                                    $rootScope.clientsAll.push(currentClient);
                                }
                            });
                        }, 2000);
                    } else {
                        //$rootScope.working = false;
                        $rootScope.clientProductsFailedMessage = response.data.message;
                    }
                    if (response.status == 400) {
                        $rootScope.clientProductsFailed = true;
                        $rootScope.clientProductsFailedMessage = response.message;
                        $timeout(function() {
                            $rootScope.clientProductsFailed = false;
                            $rootScope.clientProductsFailedMessage = '';
                        }, 2000);
                    }
                });
            }
        }

        // ==================================================================================================================== //
        // CLIENT INSURERS ========================================================================================================== //

        $rootScope.openClientInsurersModal = function(client) {
            //console.log(client)
            $rootScope.clientInsurersId = client.id;
            $rootScope.clientInsurerAdd = {};
            $rootScope.clientInsurersAll = angular.copy($rootScope.insurersAll);
            var clientInsurers = angular.copy(client.insurers);
            //match clients insurers to all and set as selected
            angular.forEach(clientInsurers, function(val, key) {
                var match = _.findWhere(_.flatten($rootScope.clientInsurersAll), { id: parseInt(val.id) })
                match.selected = true;
            })
            $rootScope.clientInsurersSelected = [];
            $('#clientInsurersModal').modal('show');
        }
        $rootScope.closeClientInsurersModal = function() {
            $('#clientInsurersModal').modal('hide');
            $rootScope.clientInsurersId = null;
            $rootScope.clientInsurerAdd = {};
        }
        $rootScope.submitClientInsurer = function(insurer) {
            //console.log(insurer);
            apiService.request('POST', '/insurer', {}, insurer).then(function(response) {
                //$rootScope.working = true;
                // console.log(response);
                if (response.status == 200) {
                    //$rootScope.working = false;
                    $rootScope.clientInsurerAddSuccessful = true;
                    $timeout(function() {
                        $rootScope.clientInsurerAddSuccessful = false;
                        $('#clientInsurersModal').modal('hide');
                        apiService.request('GET', '/insurers').then(function(response) {
                            $rootScope.insurersAll = response;
                        });
                    }, 2000);
                } else {
                    //$rootScope.working = false;
                }
                if (response.status == 400) {
                    $rootScope.clientInsurerAddFailed = true;
                    $rootScope.clientInsurerAddFailedMessage = response.message;
                    $timeout(function() {
                        $rootScope.clientInsurerAddFailed = false;
                        $rootScope.clientInsurerAddFailedMessage = '';
                    }, 2000);
                }
            });
        }
        $rootScope.submitClientInsurers = function(insurers) {
            apiService.request('PUT', '/provider/' + $rootScope.clientInsurersId + '/insurers', {}, insurers).then(function(response) {
                if (response.status == 200) {
                    $rootScope.clientInsurerEditSuccessful = true;
                    $timeout(function() {
                        $rootScope.clientInsurersSelected = null;
                        $rootScope.clientInsurerEditSuccessful = false;
                        $('#clientInsurersModal').modal('hide');
                        apiService.request('GET', '/provider').then(function(response) {
                            $rootScope.clientConfig = response;
                            var currentClient = {};
                            currentClient.name = $rootScope.clientConfig.name;
                            currentClient.id = $rootScope.clientConfig.id;
                            currentClient.products = $rootScope.clientConfig.products;
                            currentClient.insurers = $rootScope.clientConfig.insurers;
                            currentClient.admins = $rootScope.clientConfig.admins;
                            currentClient.shortcode = $rootScope.clientConfig.shortcode;
                            currentClient.search_all_customers = $rootScope.clientConfig.search_all_customers;
                            currentClient.view_all_providers = $rootScope.clientConfig.view_all_providers;
                            currentClient.edit_customer_details = $rootScope.clientConfig.edit_customer_details;
                            currentClient.edit_reminders = $rootScope.clientConfig.edit_reminders;
                            currentClient.view_data_breaches = $rootScope.clientConfig.view_data_breaches;
                            currentClient.edit_rewards = $rootScope.clientConfig.edit_rewards;
                            currentClient.xero_invoicing = $rootScope.clientConfig.xero_invoicing;
                            if ($rootScope.clientConfig.clients) {
                                $rootScope.clientsAll = angular.copy($rootScope.clientConfig.clients);
                                $rootScope.clientsAll.unshift(currentClient);
                            } else {
                                $rootScope.clientsAll = [];
                                $rootScope.clientsAll.push(currentClient);
                            }
                        });
                    }, 2000);
                }
                if (response.status == 400) {
                    $rootScope.clientInsurerEditFailed = true;
                    $rootScope.clientInsurerEditFailedMessage = response.message;
                    $timeout(function() {
                        $rootScope.clientInsurerEditFailed = false;
                        $rootScope.clientInsurerEditFailedMessage = '';
                    }, 2000);
                }
            });
        }
        $rootScope.selectedInsurers = function() {
            $rootScope.clientInsurersSelected = $filter('filter')($rootScope.clientInsurersAll, { selected: true });
        }





































        // ==================================================================================================================== //
        // REMINDERS ========================================================================================================== //
        $scope.addReminder = function() {
            $rootScope.addReminder = {};
            $rootScope.addReminderSuccessful = false;
            $('#addReminderModal').modal('show');
        }

        $rootScope.closeAddReminderModal = function() {
            $('#addReminderModal').modal('hide');
        }

        $rootScope.addAddReminderAttachment = function() {
            if (!$rootScope.addReminder.attachedDocument) {
                $rootScope.addReminder.attachedDocument = [];
            }
            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    var dataToPush = {
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    $rootScope.addReminder.attachedDocument.push(dataToPush);
                    $rootScope.$apply();
                },
                function(FPError) {}
            );
        }

        $rootScope.removeAddReminderAttachment = function(index) {
            swal({
                title: "Are you sure you want to delete this attachment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                $rootScope.addReminder.attachedDocument.splice(index, 1);
                $rootScope.$apply();
            }).catch(swal.noop);

        }

        $rootScope.submitAddReminder = function(reminder) {
            var dataToSend = {
                customer: $scope.previousId.id,
                subject: reminder.subject,
                body: reminder.body,
                date: reminder.date,
                sentToEmail: reminder.emailReminder,
                documents: reminder.attachedDocument,
                emailDate: reminder.emailDate
            }
            apiService.request('POST', '/reminder', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.addReminderSuccessful = true;
                    $timeout(function() {
                        reminder = {};
                        $rootScope.addReminderSuccessful = false;
                        $('#addReminderModal').modal('hide');
                        apiService.request('GET', '/reminder/' + $scope.previousId.id).then(function(response) {
                            $rootScope.reminders = response;
                        });
                    }, 2000);
                }
            });
        }

        $scope.editReminder = function(reminder) {
            $('#editReminderModal').modal('show');
            console.log(reminder, 'reminder')
            $rootScope.editReminderObj = {};
            $rootScope.editReminderObj.id = reminder.id;
            $rootScope.editReminderObj.subject = reminder.subject;
            $rootScope.editReminderObj.body = reminder.body;
            $rootScope.editReminderObj.date = new Date(reminder.due);
            $rootScope.editReminderObj.emailReminder = reminder.dont_send_email;
            $rootScope.editReminderObj.attachedDocument = reminder.documents;
            $rootScope.editReminderObj.emailDate = new Date(reminder.send_email_date);
        }

        $('#editReminderModal').on('hidden.bs.modal', function(e) {
            $rootScope.closeEditReminderModal();
        });

        $rootScope.closeEditReminderModal = function() {
            $('#editReminderModal').modal('hide');
            $rootScope.editReminder = null;
            apiService.request('GET', '/reminder/' + $scope.previousId.id).then(function(response) {
                if (response.status == 200) {
                    $rootScope.reminders = response;
                }
            });
        }

        $rootScope.submitEditReminder = function(reminder) {
            var dataToSend = {
                id: reminder.id,
                customer: $scope.previousId.id,
                subject: reminder.subject,
                body: reminder.body,
                date: reminder.date,
                sentToEmail: reminder.emailReminder,
                documents: reminder.attachedDocument,
                emailDate: reminder.emailDate
            }
            apiService.request('PUT', '/reminder', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editReminderSuccessful = true;
                    $timeout(function() {
                        $rootScope.editReminderSuccessful = false;
                        $('#editReminderModal').modal('hide');
                        apiService.request('GET', '/reminder/' + $scope.previousId.id).then(function(response) {
                            $rootScope.reminders = response;
                        });
                    }, 2000);
                }
            });
        }

        $rootScope.addEditReminderAttachment = function() {
            if (!$rootScope.editReminderObj.attachedDocument) {
                $rootScope.editReminderObj.attachedDocument = [];
            }
            filepicker.pick({
                    mimetypes: ['image/jpeg', 'image/png', 'application/pdf'],
                    services: ['COMPUTER', 'DROPBOX', 'GOOGLE_DRIVE', 'EVERNOTE', 'SKYDRIVE']
                },
                function(Blob) {
                    var dataToPush = {
                        filename: Blob.filename,
                        url: Blob.url,
                        mimetype: Blob.mimetype,
                        key: Blob.key
                    }
                    $rootScope.editReminderObj.attachedDocument.push(dataToPush);
                    $rootScope.$apply();
                },
                function(FPError) {}
            );
        }

        $rootScope.removeEditReminderAttachment = function(index) {
            swal({
                title: "Are you sure you want to remove this document?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, remove",
                closeOnConfirm: true
            }).then((selection) => {
                $rootScope.editReminder.attachedDocument.splice(index, 1);
                $rootScope.$apply();
            }).catch(swal.noop);
        }

        $scope.deleteReminder = function(reminder) {
            swal({
                title: "Are you sure you want to delete this reminder?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, delete",
                closeOnConfirm: true
            }).then((selection) => {
                apiService.request('DELETE', '/reminder/' + reminder.id).then(function(response) {
                    apiService.request('GET', '/reminder/' + $scope.previousId.id).then(function(response) {
                        $rootScope.reminders = response.data.data;
                    });
                    $state.reload();
                });
            }).catch(swal.noop);
        }

        $rootScope.checkForDateOnAdd = function(item) {
            if ($rootScope.addReminder.dueDate != null) {
                $rootScope.addReminder.dueDate = null
            }
            if (item.date != '') {
                var newDate = item.date + 'T12:00:00.000Z'
                $rootScope.addReminder.dueDate = new Date(moment(newDate))
            }
        }
        $rootScope.checkForDateOnEdit = function(item) {
            if ($rootScope.editReminder.date != null) {
                $rootScope.editReminder.date = null
            }
            if (item.date != '') {
                var newDate = item.date + 'T12:00:00.000Z'
                $rootScope.editReminder.date = new Date(moment(newDate))
            }
        }

        $rootScope.events = [{
                name: 'Winter Car Check',
                date: ''
            },
            {
                name: 'Tyre Pressure Check',
                date: ''
            },
            {
                name: 'Oil Check',
                date: ''
            },
            {
                name: 'Screen wash Check',
                date: ''
            },
            {
                name: 'MOT',
                date: ''
            },
            {
                name: 'Tax Return (Corporate)',
                date: ''
            },
            {
                name: 'Tax Return (Self-Assessment)',
                date: ''
            },
            {
                name: 'VAT Return',
                date: ''
            },
            {
                name: 'Car Tax',
                date: ''
            },
            {
                name: 'Council Tax',
                date: ''
            },
            {
                name: 'Car Lease Expiry',
                date: ''
            },
            {
                name: 'Bank Appointment',
                date: ''
            },
            {
                name: 'Monthly Shop',
                date: ''
            },
            {
                name: 'Mortgage Renewal',
                date: ''
            },
            {
                name: 'Tenancy Renewal',
                date: ''
            },
            {
                name: 'ISA Deadline',
                date: ''
            },
            {
                name: 'Meter Reading - Gas',
                date: ''
            },
            {
                name: 'Meter Reading - Leccy',
                date: ''
            },
            {
                name: 'Meter Reading - Water',
                date: ''
            },
            {
                name: 'Payday',
                date: ''
            },
            {
                name: 'Holiday/Vacation',
                date: ''
            },
            {
                name: 'Dental Check',
                date: ''
            },
            {
                name: 'Opticians',
                date: ''
            },
            {
                name: 'Eye Test',
                date: ''
            },
            {
                name: 'Fitness Test',
                date: ''
            },
            {
                name: 'Gym Membership',
                date: ''
            },
            {
                name: 'Club Membership',
                date: ''
            },
            {
                name: 'Medical',
                date: ''
            },
            {
                name: 'To Do - Life Admin',
                date: ''
            },
            {
                name: 'Wedmin',
                date: ''
            },
            {
                name: 'Wedding Day',
                date: ''
            },
            {
                name: 'Engagement Day',
                date: ''
            },
            {
                name: 'Insurance Renewal',
                date: ''
            },
            {
                name: 'Share Insurance',
                date: ''
            },
            {
                name: 'Continued Professional Development',
                date: ''
            },
            {
                name: 'CPD',
                date: ''
            },
            {
                name: 'Exam',
                date: ''
            },
            {
                name: 'Test',
                date: ''
            },
            {
                name: 'Deadline',
                date: ''
            },
            {
                name: 'Follow up',
                date: ''
            },
            {
                name: 'Call Back',
                date: ''
            },
            {
                name: 'Meeting',
                date: ''
            },
            {
                name: 'Appraisal',
                date: ''
            },
            {
                name: 'Budget',
                date: ''
            },
            {
                name: 'Election',
                date: ''
            },
            {
                name: 'Vote',
                date: ''
            },
            {
                name: 'Spring Clean',
                date: ''
            },
            {
                name: 'Anniversary',
                date: ''
            },
            {
                name: 'Birthday',
                date: ''
            },
            {
                name: 'Vet Appointment',
                date: ''
            },
            {
                name: 'Worming the Pet',
                date: ''
            },
            {
                name: 'Pet\'s Birthday',
                date: ''
            },
            {
                name: 'Last day of Hanukkah',
                date: '2017-01-01'
            },
            {
                name: 'New Year\'s Day',
                date: '2017-01-01'
            },
            {
                name: 'New Year\'s Day observed',
                date: '2017-01-02'
            },
            {
                name: 'New Year\'s Day Holiday',
                date: '2017-01-02'
            },
            {
                name: '2nd January (substitute day)',
                date: '2017-01-03'
            },
            {
                name: 'Epiphany',
                date: '2017-01-06'
            },
            {
                name: 'Orthodox Christmas Day',
                date: '2017-01-07'
            },
            {
                name: 'Orthodox New Year',
                date: '2017-01-14'
            },
            {
                name: 'Burns Night',
                date: '2017-01-25'
            },
            {
                name: 'Chinese New Year',
                date: '2017-01-28'
            },
            {
                name: 'Tu B\'Shevat (Arbor Day)',
                date: '2017-02-11'
            },
            {
                name: 'Maha Shivaratri',
                date: '2017-02-24'
            },
            {
                name: 'Carnival/Shrove Tuesday',
                date: '2017-02-28'
            },
            {
                name: 'St. David\'s Day',
                date: '2017-03-01'
            },
            {
                name: 'Carnival/Ash Wednesday',
                date: '2017-03-01'
            },
            {
                name: 'Holi',
                date: '2017-03-12'
            },
            {
                name: 'Purim',
                date: '2017-03-12'
            },
            {
                name: 'St Patrick\'s Day',
                date: '2017-03-17'
            },
            {
                name: 'March equinox',
                date: '2017-03-20'
            },
            {
                name: 'Daylight Saving Time starts',
                date: '2017-03-26'
            },
            {
                name: 'Mothering Sunday',
                date: '2017-03-26'
            },
            {
                name: 'Palm Sunday',
                date: '2017-04-09'
            },
            {
                name: 'First day of Passover',
                date: '2017-04-11'
            },
            {
                name: 'Maundy Thursday',
                date: '2017-04-13'
            },
            {
                name: 'Orthodox Good Friday',
                date: '2017-04-14'
            },
            {
                name: 'Good Friday',
                date: '2017-04-14'
            },
            {
                name: 'Holy Saturday',
                date: '2017-04-15'
            },
            {
                name: 'Orthodox Holy Saturday',
                date: '2017-04-15'
            },
            {
                name: 'Orthodox Easter',
                date: '2017-04-16'
            },
            {
                name: 'Easter Sunday',
                date: '2017-04-16'
            },
            {
                name: 'Orthodox Easter Monday',
                date: '2017-04-17'
            },
            {
                name: 'Easter Monday',
                date: '2017-04-17'
            },
            {
                name: 'Last day of Passover',
                date: '2017-04-18'
            },
            {
                name: 'St. George\'s Day',
                date: '2017-04-23'
            },
            {
                name: 'Shakespeare Day',
                date: '2017-04-23'
            },
            {
                name: 'Yom HaShoah',
                date: '2017-04-24'
            },
            {
                name: 'Isra and Mi\'raj',
                date: '2017-04-24'
            },
            {
                name: 'Early May Bank Holiday',
                date: '2017-05-01'
            },
            {
                name: 'Yom HaAtzmaut',
                date: '2017-05-02'
            },
            {
                name: 'Liberation Day',
                date: '2017-05-09'
            },
            {
                name: 'Lag B\'Omer',
                date: '2017-05-14'
            },
            {
                name: 'Ascension Day',
                date: '2017-05-25'
            },
            {
                name: 'Spring Bank Holiday',
                date: '2017-05-29'
            },
            {
                name: 'Shavuot',
                date: '2017-05-31'
            },
            {
                name: 'Pentecost',
                date: '2017-06-04'
            },
            {
                name: 'Whit Monday',
                date: '2017-06-05'
            },
            {
                name: 'Trinity Sunday',
                date: '2017-06-11'
            },
            {
                name: 'Corpus Christi',
                date: '2017-06-15'
            },
            {
                name: 'Father\'s Day',
                date: '2017-06-18'
            },
            {
                name: 'Laylat al-Qadr (Night of Destiny)',
                date: '2017-06-21'
            },
            {
                name: 'June Solstice',
                date: '2017-06-21'
            },
            {
                name: 'Eid-al-Fitr',
                date: '2017-06-26'
            },
            {
                name: 'Battle of the Boyne',
                date: '2017-07-12'
            },
            {
                name: 'Tisha B\'Av',
                date: '2017-08-01'
            },
            {
                name: 'Raksha Bandhan',
                date: '2017-08-07'
            },
            {
                name: 'Summer Bank Holiday',
                date: '2017-08-07'
            },
            {
                name: 'Janmashtami',
                date: '2017-08-14'
            },
            {
                name: 'Assumption of Mary',
                date: '2017-08-15'
            },
            {
                name: 'Ganesh Chaturthi',
                date: '2017-08-25'
            },
            {
                name: 'Summer Bank Holiday',
                date: '2017-08-28'
            },
            {
                name: 'Eid-al-Adha',
                date: '2017-09-02'
            },
            {
                name: 'Navaratri',
                date: '2017-09-20'
            },
            {
                name: 'Rosh Hashana',
                date: '2017-09-21'
            },
            {
                name: 'Muharram/Islamic New Year',
                date: '2017-09-22'
            },
            {
                name: 'September equinox',
                date: '2017-09-22'
            },
            {
                name: 'Dussehra',
                date: '2017-09-30'
            },
            {
                name: 'Yom Kippur',
                date: '2017-09-30'
            },
            {
                name: 'Feast of St Francis of Assisi',
                date: '2017-10-04'
            },
            {
                name: 'First day of Sukkot',
                date: '2017-10-05'
            },
            {
                name: 'Last day of Sukkot',
                date: '2017-10-11'
            },
            {
                name: 'Shmini Atzeret',
                date: '2017-10-12'
            },
            {
                name: 'Simchat Torah',
                date: '2017-10-13'
            },
            {
                name: 'Diwali/Deepavali',
                date: '2017-10-19'
            },
            {
                name: 'Daylight Saving Time ends',
                date: '2017-10-29'
            },
            {
                name: 'Halloween',
                date: '2017-10-31'
            },
            {
                name: 'All Saints\' Day',
                date: '2017-11-01'
            },
            {
                name: 'All Souls\' Day',
                date: '2017-11-02'
            },
            {
                name: 'Guy Fawkes Day',
                date: '2017-11-05'
            },
            {
                name: 'Remembrance Sunday',
                date: '2017-11-12'
            },
            {
                name: 'St Andrew\'s Day',
                date: '2017-11-30'
            },
            {
                name: 'Prophet\'s Birthday',
                date: '2017-12-01'
            },
            {
                name: 'First Sunday of Advent',
                date: '2017-12-03'
            },
            {
                name: 'Feast of the Immaculate Conception',
                date: '2017-12-08'
            },
            {
                name: 'First Day of Hanukkah',
                date: '2017-12-13'
            },
            {
                name: 'Last day of Hanukkah',
                date: '2017-12-20'
            },
            {
                name: 'December Solstice',
                date: '2017-12-21'
            },
            {
                name: 'Christmas Eve',
                date: '2017-12-24'
            },
            {
                name: 'Christmas Day',
                date: '2017-12-25'
            },
            {
                name: 'Boxing Day',
                date: '2017-12-26'
            },
            {
                name: 'New Year\'s Eve',
                date: '2017-12-31'
            },
            {
                name: 'World Religion Day',
                date: '2017-01-15'
            },
            {
                name: 'Winnie the Pooh Day',
                date: '2017-01-18'
            },
            {
                name: 'Martin Luther King Day (USA)',
                date: '2017-01-18'
            },
            {
                name: 'Burns Night',
                date: '2017-01-25'
            },
            {
                name: 'Australia Day',
                date: '2017-01-26'
            },
            {
                name: 'Holocaust Memorial Day',
                date: '2017-01-27'
            },
            {
                name: 'Chinese New Year of the Rooster',
                date: '2017-01-28'
            },
            {
                name: 'Yorkshire Pudding Day',
                date: '2017-02-05'
            },
            {
                name: 'Safer Internet Day',
                date: '2017-02-07'
            },
            {
                name: 'Valentines Day',
                date: '2017-02-14'
            },
            {
                name: 'Random Acts of Kindness Day',
                date: '2017-02-17'
            },
            {
                name: 'World Book Day',
                date: '2017-03-02'
            },
            {
                name: 'International Women\'s Day',
                date: '2017-03-08'
            },
            {
                name: 'British Science Week',
                date: '2017-03-10'
            },
            {
                name: 'The Big Pedal',
                date: '2017-03-20'
            },
            {
                name: 'World Water Day',
                date: '2017-03-22'
            },
            {
                name: 'Red Nose Day',
                date: '2017-03-24'
            },
            {
                name: 'Mothering Sunday',
                date: '2017-03-26'
            },
            {
                name: 'April Fool\'s Day',
                date: '2017-04-01'
            },
            {
                name: 'ISA Deadline Day',
                date: '2017-04-05'
            },
            {
                name: 'World Heath Day',
                date: '2017-04-07'
            },
            {
                name: 'London Marathon',
                date: '2017-04-23'
            },
            {
                name: 'St George\'s Day',
                date: '2017-04-23'
            },
            {
                name: 'World Penguin Day',
                date: '2017-04-25'
            },
            {
                name: 'Tour De Yorkshire',
                date: '2017-04-28'
            },
            {
                name: 'National Walking Month',
                date: '2017-05-01'
            },
            {
                name: 'National Share a Story Month',
                date: '2017-05-01'
            },
            {
                name: 'Donkey Week',
                date: '2017-05-02'
            },
            {
                name: 'Red Cross Week',
                date: '2017-05-07'
            },
            {
                name: 'VE Day',
                date: '2017-05-08'
            },
            {
                name: 'National Lost Sock Day',
                date: '2017-05-09'
            },
            {
                name: 'National Limerick Day',
                date: '2017-05-12'
            },
            {
                name: 'World Fair Trade Day',
                date: '2017-05-13'
            },
            {
                name: 'World Goth Day',
                date: '2017-05-22'
            },
            {
                name: 'World Turtles Day',
                date: '2017-05-23'
            },
            {
                name: 'English Wine Week',
                date: '2017-05-27'
            },
            {
                name: 'National BBQ Week',
                date: '2017-05-29'
            },
            {
                name: 'Oak Apple Day',
                date: '2017-05-29'
            },
            {
                name: 'World Milk Day',
                date: '2017-06-01'
            },
            {
                name: 'National Fish & Chip Day',
                date: '2017-06-02'
            },
            {
                name: 'World Oceans Day',
                date: '2017-06-08'
            },
            {
                name: 'Bike Week',
                date: '2017-06-10'
            },
            {
                name: 'Men\'s Health Week',
                date: '2017-06-12'
            },
            {
                name: 'World Blood Day',
                date: '2017-06-14'
            },
            {
                name: 'National Beer Day',
                date: '2017-06-15'
            },
            {
                name: 'Father\'s Day',
                date: '2017-06-18'
            },
            {
                name: 'World Humanist Day',
                date: '2017-06-21'
            },
            {
                name: 'Bring your Dog to Work Day',
                date: '2017-06-23'
            },
            {
                name: 'Armed Forces Day',
                date: '2017-06-24'
            },
            {
                name: 'National Kissing Day',
                date: '2017-06-24'
            },
            {
                name: 'Canada Day',
                date: '2017-07-01'
            },
            {
                name: 'National Parks Week',
                date: '2017-07-24'
            },
            {
                name: 'Yorkshire Day',
                date: '2017-08-01'
            },
            {
                name: 'International Cat Day',
                date: '2017-08-08'
            },
            {
                name: 'International Left Handers Awareness Day',
                date: '2017-08-13'
            },
            {
                name: 'Roald Dahl Day',
                date: '2017-09-13'
            },
            {
                name: 'National Quiet Day',
                date: '2017-09-14'
            },
            {
                name: 'International Talk Like a Pirate Day',
                date: '2017-09-19'
            },
            {
                name: 'National Doodle Day',
                date: '2017-09-22'
            },
            {
                name: 'Jeans for Genes Day',
                date: '2017-09-22'
            },
            {
                name: 'Black History Month UK',
                date: '2017-10-01'
            },
            {
                name: 'International Coffee Day',
                date: '2017-10-01'
            },
            {
                name: 'World Animal Day',
                date: '2017-10-04'
            },
            {
                name: 'National Badger Day',
                date: '2017-10-06'
            },
            {
                name: 'National Coming Out Day',
                date: '2017-10-11'
            },
            {
                name: 'International Skeptics Day (or is it?)',
                date: '2017-10-13'
            },
            {
                name: 'King Harold Day (Waltham Abbey)',
                date: '2017-10-15'
            },
            {
                name: 'World Food Day',
                date: '2017-10-16'
            },
            {
                name: 'Anti-Slavery Day',
                date: '2017-10-18'
            },
            {
                name: 'Halloween',
                date: '2017-10-31'
            },
            {
                name: 'Movember',
                date: '2017-11-01'
            },
            {
                name: 'Novel Writing Month',
                date: '2017-11-01'
            },
            {
                name: 'National Sandwich Day',
                date: '2017-11-03'
            },
            {
                name: 'Guy Fawkes Night',
                date: '2017-11-05'
            },
            {
                name: 'Rememberance Day',
                date: '2017-11-11'
            },
            {
                name: 'World Diabetes Day',
                date: '2017-11-14'
            },
            {
                name: 'World Toilet Day',
                date: '2017-11-19'
            },
            {
                name: 'International Men\'s Day',
                date: '2017-11-19'
            },
            {
                name: 'Black Friday',
                date: '2017-11-24'
            },
            {
                name: 'St Andrew\'s Day',
                date: '2017-11-30'
            },
            {
                name: 'World Aids Day',
                date: '2017-12-01'
            },
            {
                name: 'Human Rights Day',
                date: '2017-12-10'
            }
        ]


        // =====================================
        // Edit Renewal Settings

        $scope.editRenewalSettings = function(renewal) {

            $('#editRenewalModal').modal('show');
            $rootScope.editRenewal = {};
            $rootScope.editRenewal.id = renewal.id;
            $rootScope.editRenewal.prevent_renewals = renewal.prevent_renewals;
        }

        $rootScope.submitEditRenewal = function(renewal) {
            var dataToSend = {
                id: renewal.id,
                prevent_renewals: renewal.prevent_renewals
            }
            apiService.request('PUT', '/policy/' + renewal.id + '/prevent-renewals', {}, dataToSend).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editRenewalSuccessful = true;
                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/policies').then(function(response) {
                        if (response.status == 200) {
                            $rootScope.products = response;
                        }
                    });

                    $timeout(function() {
                        $rootScope.editRenewalSuccessful = false;
                        $('#editRenewalModal').modal('hide');
                    }, 2000);
                }
            });
        }

        $rootScope.closeEditRenewalModal = function() {
            $('#editRenewalModal').modal('hide');
        }





















        // ==================================================================================================================== //
        // LOGOUT FROM VALHALLA =============================================================================================== //
        $rootScope.logout = function() {
            //set the sweet alert for the logout message
            swal({
                title: "Are you sure you want to logout?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#149fba",
                confirmButtonText: "Yes, logout",
                closeOnConfirm: true
            }).then((selection) => {
                //clear everything out of localStorage (membrs token)
                localStorage.clear();
                //redirect back to login page
                $window.location = 'https://apollo11.cycler.co.uk';
            }).catch(swal.noop);

        }

        $rootScope.providers = [
            'AA', 'Abbey Life', 'AChoice', 'Admiral Group', 'Admiral Insurance', 'Admiral Little Box',
            'Adrian Flux Insurance Services', 'Allianz', 'Allied Dunbar', 'Amlin', 'Ansvar Insurance',
            'Antony Gibbs & Sons', 'Aon', 'Autonet Insurance Group', 'AutoSaint', 'Aviva', 'AXA PPP Healthcare', 'AXA UK',
            'Be Wiser Insurance', 'Beagle Street', 'Beazley Group', 'Bell', 'Benfield Group', 'Bennetts', 'BG Insurance',
            'BGL Group', 'Brand Partners', 'Bridle Insurance', 'Brightside Group', 'Brit PLC', 'British Insurance Services',
            'Budget Insurance', 'Camberford Law', 'Carole Nash', 'Carrot', 'Castle Cover', 'CGU plc', 'Chart well',
            'Chaucer Holdings', 'ChoiceQuote Insurance Services', 'Churchill Insurance', 'Clements WorldWide',
            'Clerical Medical', 'Collingwood', 'Combined Insurance', 'Cornish Mutual', 'Countrywide Legal Indemnities',
            'CoverBox', 'Daily Mail and General Trust', 'Devitt Insurance', 'Dial Direct', 'Diamond', 'Direct Choice',
            'Direct Line', 'Drive', 'Drive like a Girl', 'Drive Smart', 'Drivology', 'Eagle Star Insurance',
            'Ecclesiastical Insurance', 'Elephant', 'Endsleigh Insurance', 'Engage Mutual Assurance', 'Equitas',
            'Equity Insurance Group', 'ESInsure', 'Esure', 'Excel Insurance Solutions', 'First Central', 'First for Insurance',
            'Flux Direct', 'Forces Financial', 'Friends Provident', 'General Accident', 'GirlMotor', 'GoGirl', 'GoSkippy',
            'Grove and Dean', 'Guardian Assurance Company', 'Guardian Royal Exchange Assurance',
            'Hand in Hand Fire & Life Insurance Society', 'Hastings Insurance', 'Health Shield', 'Health-on-Line',
            'Helpucover', 'Howden Insurance Brokers Limited', 'Hughes', 'Hyperperformance', 'Ignition', 'Ignotion',
            'Igo4insurance', 'Ingenie', 'Insure and Drive', 'Insure It All', 'Insure Ok', 'Insure Pink', 'Insure the Box',
            'Insure wiser', 'Insure your Motor', 'InsureandGo', 'John Lewis', 'Kwelm', 'Kwik FIt', 'LadyBird', 'Lancaster',
            'Legal & General', 'Legal and General', 'Lifesure Insurance Group', 'Liverpool Victoria',
            'Lloyd\'s Agency Network', 'Lloyds Bank', 'Logical Choice', 'Markerstudy Group', 'Marks and Spencers',
            'Master Quote', 'MCE Insurance', 'More Than (company)', 'Motor Insurers\' Bureau', 'Municipal Mutual Insurance',
            'My motor Quote', 'MyPolicy', 'Nationwide', 'NCI Insurance', 'NFU Mutual', 'Nissan',
            'North British and Mercantile Insurance', 'North of England P&I Association', 'Northern Star Insurance Co',
            'Norwich Union', 'Novae Group', 'Octagon', 'Old Mutual', 'One Call', 'One Quote', 'Only Young Driver',
            'Pavilion Insurance', 'Peoples Choice', 'Performance Direct', 'Petplan Equine', 'Petplan UK', 'Phoenix Fire Office',
            'Phoenix Group', 'PinkPound Insurance', 'Police Mutual', 'Pool Re', 'Post Office', 'PremiumCHoice', 'Privilege',
            'Privilege (insurance company)', 'Protect Your Bubble', 'Provident', 'Prudential', 'QuickSure', 'Quote a Car',
            'Quote Line Direct', 'Quote me Happy', 'RAC', 'RAC Insurance', 'Refuge Assurance Company', 'Renault',
            'Resolution Plc', 'Rias', 'Right Choice Insurance Brokers', 'Royal Exchange Assurance Corporation',
            'Royal Liver Assurance', 'Royal London Group', 'RSA Insurance Group', 'Saffron Insurance Services Ltd', 'Saga',
            'Sainsburys', 'Scottish Friendly', 'Scottish Widows', 'ScreenTrade', 'Sedgwick Group', 'Sheila\'s Wheels',
            'Simply Business', 'Stonebridge International Insurance Ltd', 'Suffolk Life',
            'Sun Life & Provincial Holdings', 'Sun Life Financial', 'SunLife', 'Sure Thing', 'Sureterm', 'SwiftCover',
            'Swiftcover', 'Swinton', 'Swinton Insurance', 'Tesco', 'The Co-operative Insurance',
            'The Equitable Life Assurance Society', 'The Insurance Factory', 'The Insurance Line', 'Totally Insured',
            'UIA (Insurance)', 'Vauxhall', 'VitalityHealth', 'Westfield Health', 'Willis Group', 'Wise Driving', 'Wiser Choice',
            'Young Marmalade', 'Zenith', 'Zurich Insurance Group', 'Tokio Marine HCC', 'Hiscox', 'Lorega',
            'Commercial Express', 'Professional Insurance Agents', 'NIG', 'Powerplace', 'Towergate Underwriting',
            'Pen Underwriting', 'Accelerate Underwriting', 'Gable', 'Ageas'
        ];







        // ==================================================================================================================== //
        // DISCOUNT PAGE LOGIC ================================================================================================ //
        apiService.request('GET', '/rewards').then(function(response) {
            // console.log('Response from the rewards: ', response)
            if (response.status == 200) {
                $rootScope.rewardCodes = response;
            }
        });

        // ============================================================================================================= //
        // OPENS ADD PRODUCT MODAL AND MAKES OBJECT ==================================================================== //
        $scope.openAddRewardModal = function() {
                $rootScope.addReward = {};
                $('#addRewardModal').modal('show');
            }
            // ============================================================================================================= //
            // CLOSES ADD PRODUCT MODAL ++++++++++++++++==================================================================== //
        $rootScope.closeAddRewardModal = function() {
                $('#addRewardModal').modal('hide');
                $rootScope.addReward = null;
            }
            // ========================================================================================================== //
            // SUBMIT THE ADD PRODUCT FORM ============================================================================== //
        $rootScope.submitAddReward = function(reward) { // POST //
                apiService.request('POST', '/reward', {}, reward).then(function(response) {
                    $rootScope.working = true;
                    // console.log(response);
                    if (response.status == 200) {
                        $rootScope.addRewardSuccessful = true;
                        $timeout(function() {
                            $rootScope.working = false;
                            $rootScope.addRewardSuccessful = false;
                            $('#addRewardModal').modal('hide');
                            apiService.request('GET', '/rewards').then(function(response) {
                                // console.log('Response from the rewards: ', response)
                                if (response.status == 200) {
                                    $rootScope.rewardCodes = response;
                                }
                            });
                        }, 2000);
                    } else {
                        $rootScope.working = false;
                    }
                    if (response.status == 400) {
                        $rootScope.addRewardFailed = true;
                        $rootScope.addRewardFailedMessage = response.message;
                        $timeout(function() {
                            $rootScope.addRewardFailed = false;
                            $rootScope.addRewardFailedMessage = '';
                        }, 2000);
                    }
                });

                // console.log('In add reward');

            }
            // ========================================================================================================== //
            // DELETE ON OPTION FROM THIS QUOTE ========================================================================= //
        $scope.deleteReward = function(reward) { // DELETE //

            swal({
                    title: "Are you sure you want to delete this reward?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#149fba",
                    confirmButtonText: "Yes, delete",
                    closeOnConfirm: true
                })
                .then((selection) => {

                    apiService.request('DELETE', '/reward/' + reward.id).then(function(response) {
                        if (response.status == 200) {
                            apiService.request('GET', '/rewards').then(function(response) {
                                $rootScope.rewardCodes = response;
                            });
                        }
                    });

                })
                .catch(swal.noop);


        }

        $scope.openEditRewardModal = function(reward) {
            $rootScope.editReward = {};
            $rootScope.editReward = angular.copy(reward); //copy the value so we dont have the live editting thing
            $('#editRewardModal').modal('show');
        }

        $rootScope.submitEditReward = function(reward) { // PUT //
            // console.log('Reward object: ', reward)
            apiService.request('PUT', '/reward/' + reward.id, {}, reward).then(function(response) {
                if (response.status == 200) {
                    $rootScope.editRewardSuccessful = true;
                    $timeout(function() {
                        $rootScope.editReward = {};
                        $rootScope.editRewardSuccessful = false;
                        $('#editRewardModal').modal('hide');
                        apiService.request('GET', '/rewards').then(function(response) {
                            $rootScope.rewardCodes = response;
                        });
                    }, 2000);
                }
            });
        }
        $rootScope.closeEditRewardModal = function() {
            $('#editRewardModal').modal('hide');
            $rootScope.editReward = null;
        }

        $rootScope.allProductsSelected = function(rewardProducts, rewardType) {
            if (rewardProducts.all == true) {
                angular.forEach(rewardProducts, function(val, key) {
                    if (val == true && key != 'all') {
                        $rootScope[rewardType].products[key] = false
                    }
                })
            }
        }

        $rootScope.checkboxValidity = function(object) {
            var switcher = true
            for (var key in object) {
                if (object[key] == true) {
                    switcher = false
                    break
                } else { switcher = true }
            }
            return switcher
        }


        ///////////////// Rooster functions
        $rootScope.loadRoosterQuote = function(hash) {

            console.log(hash, 'Hash in loadRoosterQuote');
            console.log($scope.token, '$scope.token in loadRoosterQuote');

            window.open('https://api.joinrooster.co.uk/load.php?provider=mulsanne&type=admin&hash=' + hash + '&jwt=' + $scope.token, '_blank');

        }

        $rootScope.loadRoosterTelematicsQuote = function(hash) {

            console.log(hash, 'Hash in loadRoosterQuote');
            console.log($scope.token, '$scope.token in loadRoosterQuote');

            //window.open('https://quote-web-app-3rgbg6xlfa-ew.a.run.app/admin/' + hash +'/'+$scope.token, '_blank');
            window.open('https://api.joinrooster.co.uk/load.php?provider=markerstudy&type=admin&hash=' + hash + '&jwt=' + $scope.token, '_blank');

        }

        $rootScope.createRoosterRenewalQuote = function(id,renewalDate){

            var dataToPush = {id:id,renewalDate:renewalDate}


            apiService.request('POST', 'https://api.joinrooster.co.uk/renewal/'+id+'?authorization=NxbKs9RJf8-rWrqZGv2Ct-qGPq27VUEC', {}, dataToPush).then(function(response) {
                // console.log('Response from the rewards: ', response)
                if (response.status == 200) {

                    apiService.request('GET', '/customer/' + $scope.previousId.id + '/quotes').then(function(response) {
                        $rootScope.quotes = response;
                        var i = 0;
                        for (i = 0; i < $rootScope.quotes.length; i++) {
                            if ($rootScope.quotes[i].status != null) {
                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                            }
                        }
                    });

                    $('html, body').animate({
                        scrollTop: $("#quotesContainer").offset().top
                    }, 500);
                }
            });

        }


        $rootScope.createRoosterMsRenewalQuote = function(product,renewalDate){

            apiService.useAuthHeader(true);
            apiService.request('POST', 'https://rooster-api-agmnwch2gq-nw.a.run.app/v1/quote/renewal/'+product.policy_code, {}, {}).then(function(response) {
                // console.log('Response from the rewards: ', response)
                if (response.status == 200) {

                    apiService.request('GET', '/customer/' + product.customer_id + '/quotes').then(function(response) {
                        $rootScope.quotes = response;
                        var i = 0;
                        for (i = 0; i < $rootScope.quotes.length; i++) {
                            if ($rootScope.quotes[i].status != null) {
                                $rootScope.quotes[i].status = $rootScope.quotes[i].status.toString();
                            }
                        }
                    });

                    $('html, body').animate({
                        scrollTop: $("#quotesContainer").offset().top
                    }, 500);
                }
            });

            apiService.useAuthHeader(false);

        }




        $rootScope.sendRoosterCancellationEmail = function(id){

            var dataToPush = {id:id}

            apiService.request('POST', 'https://api.joinrooster.co.uk/cancellation/'+id+'?authorization=NxbKs9RJf8-rWrqZGv2Ct-qGPq27VUEC', {}, dataToPush).then(function(response) {
                console.log('Response from the sendRoosterCancellationEmail: ', response)
                if (response.status == 200) {

                    swal({
                        title: 'Cancellation email sent',
                        timer: 3000,
                        type: 'success',
                        showConfirmButton: false
                    });

                }
            });

        }


        $rootScope.sendRoosterQuoteEmail = function(hash){

            var dataToPush = {id:id}

            apiService.request('POST', 'https://api.joinrooster.co.uk/quote/email/'+hash+'?authorization=NxbKs9RJf8-rWrqZGv2Ct-qGPq27VUEC', {}, dataToPush).then(function(response) {
                console.log('Response from the sendRoosterCancellationEmail: ', response)
                if (response.status == 200) {

                    swal({
                        title: 'Quote email sent',
                        timer: 3000,
                        type: 'success',
                        showConfirmButton: false
                    });

                }
            });

        }

        $rootScope.createMsPolicyNumber = function(sequentialNumber,productType){

            sequentialNumber = sequentialNumber.toString();
            var requiredNumbers = 7-sequentialNumber.length;
            console.log(requiredNumbers,'requiredNumbers')
            var i=1;
            var policySystemNumber = '';
            
            while(requiredNumbers >= i){
                policySystemNumber = policySystemNumber+'0';
                i++;
            }

            policySystemNumber = policySystemNumber+sequentialNumber;

            if(productType == 'MKSRSTM'){
               return 'M964165'+policySystemNumber+' (Telematics)';
            }
            else {
                return 'M964166'+policySystemNumber+' (Private Car)';
            }

        }


        $rootScope.calculateMsRefund = function(endDate,premium){

            var given = moment(endDate, "YYYY-MM-DD");
            var current = moment().startOf('day');

            //Difference in number of days
            var daysRemaining = moment.duration(given.diff(current)).asDays();

            var premiumPerDay = premium/365;

            var returnPremium = premiumPerDay*daysRemaining

            return returnPremium.toFixed(2);

        }




    }
]);

/*
// configure our routes
angular.module('wpMarketplace').config(function($stateProvider, $urlRouterProvider, $locationProvider, $provide, $httpProvider) {

    $stateProvider
    .state('search', {
        url: '/',
        templateUrl: 'assets/templates/search.template.html',
        controller: 'wpMarketplaceController'
    })

    .state('profile', {
        url: '/profile',
        templateUrl: 'assets/templates/profile.template.html',
        controller: 'wpMarketplaceController'
    })

    .state('rewards', {
        url: '/rewards',
        templateUrl: 'assets/templates/rewardCodes.template.html',
        controller: 'wpMarketplaceController'
    })

    .state('clients', {
        url: '/clients',
        templateUrl: 'assets/templates/clients.template.html',
        controller: 'wpMarketplaceController'
    })

    $urlRouterProvider.otherwise('/');

    $locationProvider.html5Mode(true);

    $provide.decorator('$sniffer', function($delegate) {
      return $delegate;
    });

    $httpProvider.interceptors.push('authInterceptor');

}).run(function($location, $state, $window, $http, $timeout){

    if( $location.port() === 8888 ){
        var membrsUrl = 'https://signin.worryandpeace.com';
        var membrsApi = 'https://staging.memb.rs';
    } else if( $location.host() === 'marketplace-dev.worryandpeace.com' ) {
        var membrsUrl = 'https://worryandpeace-signin-dev.staging.memb.rs';
        var membrsApi = 'https://staging.memb.rs';
    } else {
        var membrsUrl = 'https://signin.worryandpeace.com';
        var membrsApi = 'https://staging.memb.rs';
    }

    if($location.search().membrs){
        // need to reissue the token on first request
        //http://api.membrs.nc-dev.co.uk
        $http.get(membrsApi+'/api/v1/token/'+$location.search().membrs+'/reissue').then(function(response){
            if(response.data.token){
                $window.localStorage.membrs = response.data.token;
                //$state.reload();
            }else {
                alert('An error occurred when logging you in')
            }
        }, function(error){
            // delete token if it exists
            if($window.localStorage.membrs)
                $window.localStorage.removeItem('membrs');
            $window.location = membrsUrl+'/login'
        });

    } else {

        $timeout(function() {
            if($window.localStorage.length == 0) {
                $window.location = membrsUrl+'/login';
            }
        }, 500);       

    }

});
*/

/*
angular.module('wpMarketplace').factory('authInterceptor', function ($q, $window, $location, $rootScope) {
    return {
        request: function (config) {
            if( $location.port() === 8888 ){
                var regex = new RegExp(/^http:\/\/api\.worryandpeace:8888/);
            } else if( $location.host() === 'marketplace-dev.worryandpeace.com' ) {
                var regex = new RegExp(/^https:\/\/api\.worryandpeace\.com/); 
            } else {
                var regex = new RegExp(/^https:\/\/api\.worryandpeace\.com/);
            }
            // add headers to just API requests
            //var regex = new RegExp(/^https:\/\/api\.worryandpeace/);
            if(regex.test(config.url) && $window.localStorage.membrs){
                config.headers = config.headers || {};
                config.headers['X-Authorization'] = $window.localStorage.membrs;
                //console.log(config.headers);
            }
            
            //console.log(config.headers);
            return config;
        },
        response: function (response) {
            return response || $q.when(response);
        }, 

        responseError: function (error){
            if (error.status === 401) {
                // remove token, redirect to login page
                if($window.localStorage.membrs)
                    $window.localStorage.removeItem('membrs');
                $window.location = 'https://signin.worryandpeace.com/login'
            }
            if (error.status === 500 || error.status === 400) {
                $rootScope.updatingBind = false; // enable the bind button if there is an error, for resubmitting
                $rootScope.updatingAddProduct = false;
                if(error.status === 500){ 
                    var errMsg = 'Something seems to have gone wrong, please try again'; 
                };
                if(error.status === 400){ 
                    var errMsg = error.data.message; 
                };
                swal({  
                    title: 'Oops', 
                    text: errMsg,   
                    type: "error",   
                    showCancelButton: false,   
                    confirmButtonColor: "#149fba",   
                    confirmButtonText: "Dismiss",   
                    closeOnConfirm: true 
                }, function(){  
                    //send data to Raygun
                });
            }
        }
    };
});
*/
//FILTERS
angular.module('wpMarketplace').filter('formatDate', function() {
    return function(input) {
        return moment(input).format('DD/MM/YYYY');
    }
});

angular.module('wpMarketplace').filter('capitalize', function() {
    return function(input, all) {
        var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
        return (!!input) ? input.replace(reg, function(txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : '';
    }
});

angular.module('wpMarketplace').filter('formatStatus', function() {
    return function(input) {
        if (input != undefined) {
            return input.replace(/-/g, ' ');
        }
    }
});

//DIRECTIVES
angular.module('wpMarketplace').directive('documentation', function() {
    console.log('documentation directive')
    return {
        restrict: 'A',
        replace: 'false',
        scope: {
            policy: '=',
            api: '=',
            token: '='
        },
        link: function(scope, element, attrs) {

        },
        templateUrl: function(elem, attr) {
            return 'assets/templates/documentation.template.html';
        }

    };
});

angular.module('wpMarketplace').directive('searching', function() {
    return {
        restrict: 'AE',
        replace: 'true',
        scope: {
            color: '@',
            fontsize: '@'
        },
        template: '<span style="color: {{color}}; font-size: {{fontsize}}; display: inline-block; margin-top: 10px;"><span class="icon icon-refresh spin"></span><span style="margin-left: 8px;">Searching</span></span>'
    }
});

angular.module('wpMarketplace').directive('spinner', function() {
    return {
        restrict: 'AE',
        replace: 'true',
        template: '<span style="color: white; font-size: 12px; display: inline-block; margin: 10px;"><span class="icon icon-refresh spin"></span></span>'
    }
});

angular.module('wpMarketplace').directive('updating', function() {
    return {
        restrict: 'AE',
        replace: 'true',
        scope: {
            color: '@',
            fontsize: '@'
        },
        template: '<span style="color: {{color}}; font-size: {{fontsize}};"><span class="icon icon-refresh spin"></span><span style="margin-left: 8px;"></span></span>'
    }
});

angular.module('wpMarketplace').directive('infoText', function() {
    return {
        restrict: 'AE',
        replace: 'true',
        scope: {
            message: '@', //this value is used for the message that will be displayed
            width: '@', //this takes a width value, percentage, px, etc for the info text width
            icon: '@', //this dictates what icon is used - use the key word from W+P icon list /wpicons.html
            popoverposition: '@' //position of the popover
        },
        template: '<span class="info-text" ng-model="showInfoText" style="display: inline-block;"><span class="icon icon-{{icon}}" ng-click="showInfoText = ! showInfoText" ng-class="{\'icon-cross\': showInfoText}" uib-popover="{{message}}" popover-placement="{{popoverposition}}" popover-trigger="click"></span></span>'
    }
});

angular.module('wpMarketplace').directive('renewal', function() {
    return {
        restrict: 'A',
        replace: 'false',
        scope: {
            policy: '=',
            api: '=',
            token: '='
        },
        link: function(scope, element, attrs) {

        },
        templateUrl: function(elem, attr) {
            return 'assets/templates/renewal.template.html';
        }

    };
});


angular.module('wpMarketplace').directive('claims', function($rootScope) {
    return {
        restrict: 'A',
        replace: 'false',
        scope: {
            policy: '=',
            api: '=',
            token: '='
        },
        link: function(scope, element, attrs) {
            scope.addSettledClaim = function(policy) {

                $rootScope.addSettledClaim = {};
                $rootScope.addSettledClaim.id = policy.id
                $rootScope.addSettledClaimSuccessful = false;
                $rootScope.updatingAddSettledClaim = false;

                $('#settledClaimModal').modal('show');
            };

            scope.editSettledClaim = function(policy) {

                $rootScope.editSettledClaim = {};
                $rootScope.editSettledClaim.id = policy.id
                $rootScope.editSettledClaim.notes = policy.claim_details
                $rootScope.editSettledClaim.date = new Date(policy.claim_date);
                $rootScope.editSettledClaimSuccessful = false;
                $rootScope.updatingAddSettledClaim = false;
                
                $('#editSettledClaimModal').modal('show');
            };

        },




        templateUrl: function(elem, attr) {
            return 'assets/templates/claims.template.html';
        }

    };
})


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/angularjs/wpMarketplace.js
// module id = ../../../../../src/app/angularjs/wpMarketplace.js
// module chunks = 1